// @ts-nocheck
import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { graphqlBaseApi } from './services/baseApi';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  county: Scalars['String']['output'];
  fiveDigitZipcode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  state: StateName;
  street: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  zipcode: Scalars['String']['output'];
};

export type Appointment = {
  __typename?: 'Appointment';
  consumerMarket?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  integrationType?: Maybe<AppointmentIntegrationType>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isAvailableForQuoting?: Maybe<Scalars['Boolean']['output']>;
  isEnableForLeadFlow?: Maybe<Scalars['Boolean']['output']>;
  lob?: Maybe<Scalars['String']['output']>;
  market?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['String']['output']>;
  products?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['JSONObject']['output']>;
};

export enum AppointmentIntegrationType {
  Direct = 'Direct',
  Ezlynx = 'Ezlynx'
}

export enum Attachedness {
  Apartment = 'Apartment',
  AttachedEnd = 'AttachedEnd',
  AttachedInterior = 'AttachedInterior',
  CoOp = 'CoOp',
  Condo = 'Condo',
  Detached = 'Detached',
  Other = 'Other'
}

export type Basement = {
  __typename?: 'Basement';
  finishedPercent?: Maybe<Scalars['Float']['output']>;
};

export type Bathroom = {
  __typename?: 'Bathroom';
  full?: Maybe<FullBathroom>;
  half?: Maybe<HalfBathroom>;
};

export type Bedroom = {
  __typename?: 'Bedroom';
  count?: Maybe<Scalars['Int']['output']>;
};

export type Building = {
  __typename?: 'Building';
  exteriorWall?: Maybe<ExteriorWall>;
  foundation?: Maybe<Foundation>;
  garage?: Maybe<Garage>;
  general?: Maybe<General>;
  interior?: Maybe<Interior>;
  roof?: Maybe<Roof>;
  utility?: Maybe<Utility>;
};

export enum BuildingCondition {
  Average = 'Average',
  Excellent = 'Excellent',
  Fair = 'Fair'
}

export enum BuildingQuality {
  Economy = 'Economy',
  Luxury = 'Luxury',
  Premium = 'Premium',
  Standard = 'Standard'
}

export enum ConstructionStyle {
  Apartment = 'Apartment',
  Backsplit = 'Backsplit',
  BiLevel = 'BiLevel',
  BiLevelRowCenter = 'BiLevelRowCenter',
  BiLevelRowEnd = 'BiLevelRowEnd',
  Bungalow = 'Bungalow',
  CapeCod = 'CapeCod',
  Colonial = 'Colonial',
  Condo = 'Condo',
  Contemporary = 'Contemporary',
  Coop = 'Coop',
  Cottage = 'Cottage',
  Dwelling = 'Dwelling',
  FederalColonial = 'FederalColonial',
  Mediterranean = 'Mediterranean',
  OrnateVictorian = 'OrnateVictorian',
  QueenAnne = 'QueenAnne',
  RaisedRanch = 'RaisedRanch',
  Rambler = 'Rambler',
  Ranch = 'Ranch',
  Rowhouse = 'Rowhouse',
  RowhouseCenter = 'RowhouseCenter',
  RowhouseEnd = 'RowhouseEnd',
  SouthwestAdobe = 'SouthwestAdobe',
  SplitFoyer = 'SplitFoyer',
  SplitLevel = 'SplitLevel',
  Substandard = 'Substandard',
  Townhouse = 'Townhouse',
  TownhouseCenter = 'TownhouseCenter',
  TownhouseEnd = 'TownhouseEnd',
  TriLevel = 'TriLevel',
  TriLevelCenter = 'TriLevelCenter',
  Victorian = 'Victorian'
}

export type CreateAddressInput = {
  city: Scalars['String']['input'];
  county: Scalars['String']['input'];
  state: StateName;
  street: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  zipcode: Scalars['String']['input'];
};

export type CreateHomeQuoteRequestInput = {
  applicant: HomeApplicantInput;
  pageTracking?: InputMaybe<Array<PageTrackingInput>>;
  productName: ProductName;
  propertyId: Scalars['String']['input'];
  propertyRevision: Scalars['Int']['input'];
  quoteBy: QuoteRequestByInput;
  quoteMethod: QuoteRequestMethod;
  quoteType: QuoteRequestType;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  residenceType: ResidenceType;
  selectedLob: Array<LineOfBusiness>;
};

export enum Education {
  AssociatesDegree = 'AssociatesDegree',
  Bachelors = 'Bachelors',
  HighSchoolDiploma = 'HighSchoolDiploma',
  LawDegree = 'LawDegree',
  Masters = 'Masters',
  MedicalDegree = 'MedicalDegree',
  NoHighSchoolDiploma = 'NoHighSchoolDiploma',
  Phd = 'Phd',
  SomeCollege = 'SomeCollege',
  TechnicalDegree = 'TechnicalDegree'
}

export enum ErrorStatus {
  Failed = 'Failed'
}

export type ExteriorWall = {
  __typename?: 'ExteriorWall';
  finish?: Maybe<ExteriorWallFinish>;
  structure?: Maybe<ExteriorWallStructure>;
};

export enum ExteriorWallFinish {
  BrickVeneer = 'BrickVeneer',
  CementFiberClapboardSiding = 'CementFiberClapboardSiding',
  CementFiberShingle = 'CementFiberShingle',
  ClapboardWoodSiding = 'ClapboardWoodSiding',
  HardboardSiding = 'HardboardSiding',
  MasonryStucco = 'MasonryStucco',
  MetalSiding = 'MetalSiding',
  None = 'None',
  StoneVeneer = 'StoneVeneer',
  SyntheticStucco = 'SyntheticStucco',
  TongueAndGrooveWoodSiding = 'TongueAndGrooveWoodSiding',
  VinylSiding = 'VinylSiding',
  WoodShingle = 'WoodShingle'
}

export enum ExteriorWallStructure {
  LightGaugeSteelFraming = 'LightGaugeSteelFraming',
  None = 'None',
  PreEngineeredMetal = 'PreEngineeredMetal',
  SolidBrick = 'SolidBrick',
  SolidConcreteOrConcreteBlock = 'SolidConcreteOrConcreteBlock',
  SolidLog = 'SolidLog',
  SolidStone = 'SolidStone',
  TimberFraming = 'TimberFraming',
  WoodFraming = 'WoodFraming'
}

export enum FamilyUnits {
  FourFamily = 'FourFamily',
  MultiFamily = 'MultiFamily',
  SingleFamily = 'SingleFamily',
  ThreeFamily = 'ThreeFamily',
  TwoFamily = 'TwoFamily'
}

export enum FeetToNearestHydrant {
  NoneInArea = 'NoneInArea',
  '1500' = '_1500',
  '1501AndGreater' = '_1501AndGreater',
  '501600' = '_501600',
  '6011000' = '_6011000',
  '10011100' = '_10011100',
  '11011200' = '_11011200',
  '12011300' = '_12011300',
  '13011400' = '_13011400',
  '14011500' = '_14011500'
}

export type Fireplace = {
  __typename?: 'Fireplace';
  count?: Maybe<Scalars['Int']['output']>;
};

export type Foundation = {
  __typename?: 'Foundation';
  basement?: Maybe<Basement>;
  slope?: Maybe<FoundationSlope>;
  type?: Maybe<FoundationType>;
};

export enum FoundationSlope {
  '015' = '_015',
  '30' = '_30',
  '1630' = '_1630'
}

export enum FoundationType {
  Basement = 'Basement',
  ConcreteSlab = 'ConcreteSlab',
  Crawlspace = 'Crawlspace',
  PierOrPilings = 'PierOrPilings'
}

export type FullBathroom = {
  __typename?: 'FullBathroom';
  count?: Maybe<Scalars['Int']['output']>;
};

export type Garage = {
  __typename?: 'Garage';
  stall?: Maybe<Stall>;
  type?: Maybe<GarageType>;
};

export enum GarageType {
  AttachedBuiltIn = 'AttachedBuiltIn',
  Basement = 'Basement',
  Carport = 'Carport',
  Detached = 'Detached'
}

export type General = {
  __typename?: 'General';
  attachedness?: Maybe<Attachedness>;
  condition?: Maybe<BuildingCondition>;
  constructionStyle?: Maybe<ConstructionStyle>;
  familyUnits?: Maybe<FamilyUnits>;
  quality?: Maybe<BuildingQuality>;
  squareFootage?: Maybe<Scalars['Float']['output']>;
  stories?: Maybe<Stories>;
  yearBuilt?: Maybe<Scalars['Int']['output']>;
};

export type HalfBathroom = {
  __typename?: 'HalfBathroom';
  count?: Maybe<Scalars['Int']['output']>;
};

export type HippoRebuildingCost = {
  __typename?: 'HippoRebuildingCost';
  medium?: Maybe<Scalars['Float']['output']>;
};

export type HomeApplicant = {
  __typename?: 'HomeApplicant';
  dateOfBirth: Scalars['DateTime']['output'];
  education: Education;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  industry: Industry;
  lastName: Scalars['String']['output'];
  maritalStatus?: Maybe<MaritalStatus>;
  middleName?: Maybe<Scalars['String']['output']>;
  occupation: Occupation;
  phone: Scalars['String']['output'];
};

export type HomeApplicantInput = {
  dateOfBirth: Scalars['DateTime']['input'];
  education: Education;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  industry: Industry;
  lastName: Scalars['String']['input'];
  maritalStatus?: InputMaybe<MaritalStatus>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  occupation: Occupation;
  phone: Scalars['String']['input'];
};

export type HomeQuote = {
  __typename?: 'HomeQuote';
  carrierId: Scalars['String']['output'];
  carrierName: Scalars['String']['output'];
  data?: Maybe<HomeQuoteData>;
  error?: Maybe<HomeQuoteError>;
  logoUrl: Scalars['String']['output'];
  tooltip: Scalars['String']['output'];
};

export type HomeQuoteData = {
  __typename?: 'HomeQuoteData';
  agentUrl: Scalars['String']['output'];
  computers: Scalars['String']['output'];
  covA: Scalars['Float']['output'];
  covALimitAdditional?: Maybe<Scalars['Float']['output']>;
  covB: Scalars['Float']['output'];
  covC: Scalars['Float']['output'];
  covD: Scalars['Float']['output'];
  covE: Scalars['Float']['output'];
  covF: Scalars['Float']['output'];
  covL?: Maybe<Scalars['Float']['output']>;
  covM?: Maybe<Scalars['Float']['output']>;
  deductibles: PropertyDeductible;
  dicPresent?: Maybe<Scalars['String']['output']>;
  downPayment?: Maybe<Scalars['Float']['output']>;
  equipmentBreakdown?: Maybe<Scalars['Float']['output']>;
  equipmentBreakdownIncluded?: Maybe<Scalars['Boolean']['output']>;
  extendedReplacementCost?: Maybe<Scalars['Float']['output']>;
  herdId: Scalars['String']['output'];
  homeOffice?: Maybe<Scalars['Float']['output']>;
  hvac?: Maybe<Scalars['String']['output']>;
  isAdmitted?: Maybe<Scalars['Boolean']['output']>;
  isMonthlyPremiumSupported?: Maybe<Scalars['Boolean']['output']>;
  jewelry?: Maybe<Scalars['Float']['output']>;
  licenseLink?: Maybe<Scalars['String']['output']>;
  link: Scalars['String']['output'];
  lossAssessment?: Maybe<Scalars['Float']['output']>;
  monthlyPremium?: Maybe<Scalars['Float']['output']>;
  mortgagePaymentProtection?: Maybe<Scalars['Boolean']['output']>;
  numberOfMonthlyInstallments?: Maybe<Scalars['Int']['output']>;
  ordinanceOrLawProtection?: Maybe<Scalars['String']['output']>;
  personalProperty?: Maybe<Scalars['Float']['output']>;
  personalPropertyReplacementCost?: Maybe<Scalars['Boolean']['output']>;
  policyBounded?: Maybe<Scalars['Boolean']['output']>;
  price: Scalars['Float']['output'];
  product: ProductName;
  purchaseType: PurchaseType;
  quoteId: Scalars['String']['output'];
  quoteLicense?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['Int']['output']>;
  termLabel?: Maybe<TermLabel>;
  underwritingMessage: Array<UnderwritingMessageData>;
  waterBackup?: Maybe<Scalars['Float']['output']>;
};

export type HomeQuoteError = {
  __typename?: 'HomeQuoteError';
  errorCategory: QuoteCarrierErrorCategory;
  errorStatus: ErrorStatus;
  errorType?: Maybe<QuoteErrorType>;
  statusText: Scalars['String']['output'];
};

export type HomeQuotePending = {
  __typename?: 'HomeQuotePending';
  carrierId: Scalars['String']['output'];
  carrierName: Scalars['String']['output'];
  logoUrl: Scalars['String']['output'];
};

export type HomeQuoteRequest = {
  __typename?: 'HomeQuoteRequest';
  applicant: HomeApplicant;
  coverage?: Maybe<PropertyCoverage>;
  createdAt: Scalars['DateTime']['output'];
  deductible?: Maybe<PropertyDeductible>;
  id: Scalars['ID']['output'];
  pageTracking?: Maybe<Array<PageTracking>>;
  productName: ProductName;
  propertyData: PropertyData;
  propertyId: Scalars['String']['output'];
  propertyRevision: Scalars['Int']['output'];
  quoteBy: QuoteRequestBy;
  quoteMethod: QuoteRequestMethod;
  quoteType: QuoteRequestType;
  referenceId?: Maybe<Scalars['String']['output']>;
  residenceType: ResidenceType;
  selectedLob: Array<LineOfBusiness>;
  status: QuoteRequestStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type HomeQuoteRequestPoll = {
  __typename?: 'HomeQuoteRequestPoll';
  continuePolling: Scalars['Boolean']['output'];
  pendingQuotes: Array<HomeQuotePending>;
  quoteRequestStatus: QuoteRequestStatus;
  quotes: Array<HomeQuote>;
  upcomingCarriers: Array<HomeUpcomingCarrier>;
};

export type HomeUpcomingCarrier = {
  __typename?: 'HomeUpcomingCarrier';
  agentUrl?: Maybe<Scalars['String']['output']>;
  carrierId: Scalars['String']['output'];
  carrierName: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  isAvailableForQuoting: Scalars['Boolean']['output'];
  logoUrl: Scalars['String']['output'];
};

export type Homeowner = {
  __typename?: 'Homeowner';
  hasBeenVacantForAtLeast90Days?: Maybe<Scalars['Boolean']['output']>;
  isLastForeclosureForCurrentOwner?: Maybe<Scalars['Boolean']['output']>;
  lastForeclosureDate?: Maybe<Scalars['DateTime']['output']>;
  lastPurchaseDate?: Maybe<Scalars['DateTime']['output']>;
  lastPurchasePrice?: Maybe<Scalars['Float']['output']>;
  marketValue?: Maybe<Scalars['Float']['output']>;
  numberOfOpenMortgages?: Maybe<Scalars['Int']['output']>;
  ownerIsLLC?: Maybe<Scalars['Boolean']['output']>;
  ownerIsTrust?: Maybe<Scalars['Boolean']['output']>;
};

export enum Industry {
  Agriculture = 'Agriculture',
  Art = 'Art',
  Banking = 'Banking',
  Business = 'Business',
  Construction = 'Construction',
  Disabled = 'Disabled',
  Education = 'Education',
  Government = 'Government',
  Homemaker = 'Homemaker',
  HotelServices = 'HotelServices',
  InfoTech = 'InfoTech',
  Insurance = 'Insurance',
  Legal = 'Legal',
  Maintenance = 'Maintenance',
  Manufacturing = 'Manufacturing',
  MedicalService = 'MedicalService',
  Other = 'Other',
  PersonalCare = 'PersonalCare',
  Retired = 'Retired',
  Sports = 'Sports',
  Stem = 'Stem',
  Student = 'Student',
  Travel = 'Travel',
  Unemployed = 'Unemployed'
}

export type Interior = {
  __typename?: 'Interior';
  bathrooms?: Maybe<Bathroom>;
  bedrooms?: Maybe<Bedroom>;
  fireplace?: Maybe<Fireplace>;
  hasBurglarAlarm?: Maybe<Scalars['Boolean']['output']>;
  hasDeadbolt?: Maybe<Scalars['Boolean']['output']>;
  hasFireAlarm?: Maybe<Scalars['Boolean']['output']>;
  hasFireExtinguisher?: Maybe<Scalars['Boolean']['output']>;
  hasFireSprinkler?: Maybe<Scalars['Boolean']['output']>;
};

export enum LineOfBusiness {
  Auto = 'Auto',
  Cybersecurity = 'Cybersecurity',
  Flood = 'Flood',
  Home = 'Home',
  Homewarranty = 'Homewarranty',
  Life = 'Life',
  Pet = 'Pet',
  Quake = 'Quake',
  Umbrella = 'Umbrella',
  Wc = 'Wc'
}

export type Location = {
  __typename?: 'Location';
  distanceToCoast?: Maybe<Scalars['Float']['output']>;
  distanceToFireStation?: Maybe<Scalars['Float']['output']>;
  distanceToWater?: Maybe<Scalars['Float']['output']>;
  feetToNearestHydrant?: Maybe<FeetToNearestHydrant>;
  withinCityLimit?: Maybe<Scalars['Boolean']['output']>;
};

export enum MaritalStatus {
  Divorced = 'Divorced',
  DomesticPartner = 'DomesticPartner',
  Married = 'Married',
  Separated = 'Separated',
  Single = 'Single',
  Widowed = 'Widowed'
}

export type Mutation = {
  __typename?: 'Mutation';
  createHomeQuoteRequest?: Maybe<HomeQuoteRequest>;
  createPropertyData: PropertyDataCreated;
  executeQuoteRequest: Scalars['Boolean']['output'];
  updateHomeQuoteRequest?: Maybe<HomeQuoteRequest>;
  updateProperty: PropertyData;
};


export type MutationCreateHomeQuoteRequestArgs = {
  input: CreateHomeQuoteRequestInput;
};


export type MutationCreatePropertyDataArgs = {
  input: CreateAddressInput;
};


export type MutationExecuteQuoteRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateHomeQuoteRequestArgs = {
  id: Scalars['ID']['input'];
  input: UpdateHomeQuoteRequestInput;
};


export type MutationUpdatePropertyArgs = {
  input: UpdatePropertyInput;
  propertyId: Scalars['ID']['input'];
};

export enum Occupation {
  AccountExecutive = 'AccountExecutive',
  Accountant = 'Accountant',
  ActivityAssistant = 'ActivityAssistant',
  Actor = 'Actor',
  ActuarialClerk = 'ActuarialClerk',
  Actuary = 'Actuary',
  AdministrativeAssistant = 'AdministrativeAssistant',
  Agent = 'Agent',
  AgentBroker = 'AgentBroker',
  AgrocultureInspector = 'AgrocultureInspector',
  AirTrafficControl = 'AirTrafficControl',
  AirportOperationsCrew = 'AirportOperationsCrew',
  AirportSecurityOfficer = 'AirportSecurityOfficer',
  Analyst = 'Analyst',
  AnalystBroker = 'AnalystBroker',
  AnimalControlOfficer = 'AnimalControlOfficer',
  Announcer = 'Announcer',
  Arborist = 'Arborist',
  Architect = 'Architect',
  Artist = 'Artist',
  AssistantMedic = 'AssistantMedic',
  Athlete = 'Athlete',
  Attorney = 'Attorney',
  AudioVisualTechnician = 'AudioVisualTechnician',
  Author = 'Author',
  Bailiff = 'Bailiff',
  Baker = 'Baker',
  Bartender = 'Bartender',
  Bellhop = 'Bellhop',
  BellhopPorter = 'BellhopPorter',
  BoilerOperator = 'BoilerOperator',
  Bookkeeper = 'Bookkeeper',
  BranchManager = 'BranchManager',
  Bricklayer = 'Bricklayer',
  BuildingMaintenanceEngineer = 'BuildingMaintenanceEngineer',
  BusPerson = 'BusPerson',
  Buyer = 'Buyer',
  CampCounselor = 'CampCounselor',
  Caregiver = 'Caregiver',
  Carpenter = 'Carpenter',
  CarpetInstaller = 'CarpetInstaller',
  Caterer = 'Caterer',
  Chef = 'Chef',
  ChiefExecutive = 'ChiefExecutive',
  ChoreographyDancer = 'ChoreographyDancer',
  ClaimsAdjuster = 'ClaimsAdjuster',
  Clergy = 'Clergy',
  Clerk = 'Clerk',
  ClerkOffice = 'ClerkOffice',
  ClientCareWorker = 'ClientCareWorker',
  ClinicalDataCoordinator = 'ClinicalDataCoordinator',
  Coach = 'Coach',
  Collections = 'Collections',
  Commissioner = 'Commissioner',
  Composer = 'Composer',
  Concessionaire = 'Concessionaire',
  Concierge = 'Concierge',
  ConcreteWorker = 'ConcreteWorker',
  ConstructionProjectManager = 'ConstructionProjectManager',
  Consultant = 'Consultant',
  Contractor = 'Contractor',
  Controller = 'Controller',
  CookFastFood = 'CookFastFood',
  CookRestaurant = 'CookRestaurant',
  CorrectionsOfficer = 'CorrectionsOfficer',
  CouncilMember = 'CouncilMember',
  Counselor = 'Counselor',
  CourtReporter = 'CourtReporter',
  CraneLoader = 'CraneLoader',
  CranerOperator = 'CranerOperator',
  Csr = 'Csr',
  CsrTeller = 'CsrTeller',
  Curator = 'Curator',
  Custodian = 'Custodian',
  DaycareWorker = 'DaycareWorker',
  DeliveryPerson = 'DeliveryPerson',
  DentalHygenist = 'DentalHygenist',
  Dentist = 'Dentist',
  DeputySheriff = 'DeputySheriff',
  Designer = 'Designer',
  DeskClerk = 'DeskClerk',
  DillerOperator = 'DillerOperator',
  Director = 'Director',
  DirectorProgram = 'DirectorProgram',
  Disabled = 'Disabled',
  Dishwasher = 'Dishwasher',
  Dispatcher = 'Dispatcher',
  Doctor = 'Doctor',
  Drafter = 'Drafter',
  DriverBus = 'DriverBus',
  DriverTaxi = 'DriverTaxi',
  DriverTruck = 'DriverTruck',
  DryCleaner = 'DryCleaner',
  Editor = 'Editor',
  Electrician = 'Electrician',
  ElectricianLinesman = 'ElectricianLinesman',
  ElevatorTechnician = 'ElevatorTechnician',
  Engineer = 'Engineer',
  EngineerHardware = 'EngineerHardware',
  EngineerSoftware = 'EngineerSoftware',
  EngineerSystems = 'EngineerSystems',
  EnlistedMilitaryPersonnel = 'EnlistedMilitaryPersonnel',
  EquipmentOperator = 'EquipmentOperator',
  EventManager = 'EventManager',
  Examiner = 'Examiner',
  Executive = 'Executive',
  FactoryWorker = 'FactoryWorker',
  FarmOwner = 'FarmOwner',
  Farmworker = 'Farmworker',
  FederalAgent = 'FederalAgent',
  FieldServiceTechnician = 'FieldServiceTechnician',
  FinancialAdvisor = 'FinancialAdvisor',
  FireChief = 'FireChief',
  Firefighter = 'Firefighter',
  Fisherman = 'Fisherman',
  FlightAttendant = 'FlightAttendant',
  FloorLayer = 'FloorLayer',
  Florist = 'Florist',
  FoodProduction = 'FoodProduction',
  Foreman = 'Foreman',
  ForkliftOperator = 'ForkliftOperator',
  FurnitureFinisher = 'FurnitureFinisher',
  GamingOfficer = 'GamingOfficer',
  GraduateStudent = 'GraduateStudent',
  GraduateTeachingAssistant = 'GraduateTeachingAssistant',
  Handyman = 'Handyman',
  HearAirTechnician = 'HearAirTechnician',
  HearStylistBarber = 'HearStylistBarber',
  HeatAirConditionerRepairman = 'HeatAirConditionerRepairman',
  HighSchool = 'HighSchool',
  HighwayPatrolOfficer = 'HighwayPatrolOfficer',
  Homemaker = 'Homemaker',
  HospiceVolunteer = 'HospiceVolunteer',
  HostMaitre = 'HostMaitre',
  Housekeeper = 'Housekeeper',
  HousekeeperMaid = 'HousekeeperMaid',
  HrRepresentative = 'HrRepresentative',
  Inspector = 'Inspector',
  InstructorVocation = 'InstructorVocation',
  InvestmentBanker = 'InvestmentBanker',
  Investor = 'Investor',
  Jeweler = 'Jeweler',
  Journalist = 'Journalist',
  Judge = 'Judge',
  Laborer = 'Laborer',
  LaborerWorker = 'LaborerWorker',
  LandscapeMaintenance = 'LandscapeMaintenance',
  LandscapeNurseryWorker = 'LandscapeNurseryWorker',
  Landscaper = 'Landscaper',
  LegalAssistant = 'LegalAssistant',
  Legislator = 'Legislator',
  Librarian = 'Librarian',
  Lifeguard = 'Lifeguard',
  LoanProcessor = 'LoanProcessor',
  Logger = 'Logger',
  Longshoreman = 'Longshoreman',
  MachineOperator = 'MachineOperator',
  MaintenanceMechanic = 'MaintenanceMechanic',
  Manager = 'Manager',
  ManagerCredit = 'ManagerCredit',
  ManagerDistrict = 'ManagerDistrict',
  ManagerFinance = 'ManagerFinance',
  ManagerFitness = 'ManagerFitness',
  ManagerGeneralOperations = 'ManagerGeneralOperations',
  ManagerHr = 'ManagerHr',
  ManagerMarketingSales = 'ManagerMarketingSales',
  ManagerOffice = 'ManagerOffice',
  ManagerPortfolio = 'ManagerPortfolio',
  ManagerProject = 'ManagerProject',
  ManagerProperty = 'ManagerProperty',
  ManagerRd = 'ManagerRD',
  ManagerStore = 'ManagerStore',
  ManagerSystems = 'ManagerSystems',
  ManagerWarehouse = 'ManagerWarehouse',
  Manicurist = 'Manicurist',
  MarketingResearcher = 'MarketingResearcher',
  Masseuse = 'Masseuse',
  MateSailor = 'MateSailor',
  Mathematician = 'Mathematician',
  Mayor = 'Mayor',
  Mechanic = 'Mechanic',
  Messenger = 'Messenger',
  Metalworker = 'Metalworker',
  MeterReader = 'MeterReader',
  Millworker = 'Millworker',
  Miner = 'Miner',
  Mortician = 'Mortician',
  Musician = 'Musician',
  Nanny = 'Nanny',
  NcoEs9 = 'NcoEs9',
  NetworkAdmin = 'NetworkAdmin',
  NurseCna = 'NurseCna',
  NurseLpn = 'NurseLpn',
  NursePractitioner = 'NursePractitioner',
  NurseRn = 'NurseRn',
  OfficerCommissioned = 'OfficerCommissioned',
  OfficerWarrant = 'OfficerWarrant',
  Optometrist = 'Optometrist',
  Other = 'Other',
  Packer = 'Packer',
  Painter = 'Painter',
  Paralegal = 'Paralegal',
  Paramedic = 'Paramedic',
  ParkRanger = 'ParkRanger',
  ParkingLotAttendant = 'ParkingLotAttendant',
  PetServices = 'PetServices',
  Pharmacist = 'Pharmacist',
  PilotCaptain = 'PilotCaptain',
  Planner = 'Planner',
  PlantManager = 'PlantManager',
  Plaster = 'Plaster',
  Plumber = 'Plumber',
  PoliceChief = 'PoliceChief',
  PoliceInvestigator = 'PoliceInvestigator',
  PoliceOfficer = 'PoliceOfficer',
  Postmaster = 'Postmaster',
  Printer = 'Printer',
  PrinterBookbinder = 'PrinterBookbinder',
  PrivateInvestigator = 'PrivateInvestigator',
  ProcessServer = 'ProcessServer',
  Producer = 'Producer',
  ProductManager = 'ProductManager',
  ProductionCrew = 'ProductionCrew',
  Professor = 'Professor',
  Programmer = 'Programmer',
  ProjectCoordinator = 'ProjectCoordinator',
  Projectionist = 'Projectionist',
  QualityControl = 'QualityControl',
  RailroadWorker = 'RailroadWorker',
  Ranger = 'Ranger',
  Realtor = 'Realtor',
  Receptionist = 'Receptionist',
  RefiningOperator = 'RefiningOperator',
  Regulator = 'Regulator',
  ResearchProgramDirector = 'ResearchProgramDirector',
  Researcher = 'Researcher',
  Retired = 'Retired',
  Roofer = 'Roofer',
  SalesAgent = 'SalesAgent',
  SalesCounter = 'SalesCounter',
  SalesHome = 'SalesHome',
  SalesManufacture = 'SalesManufacture',
  SalesMembership = 'SalesMembership',
  SalesRepresentative = 'SalesRepresentative',
  SalesRetail = 'SalesRetail',
  SalesVendor = 'SalesVendor',
  Scientist = 'Scientist',
  SecurityGuard = 'SecurityGuard',
  Sheriff = 'Sheriff',
  ShippingClerk = 'ShippingClerk',
  Shoemaker = 'Shoemaker',
  SocialWorker = 'SocialWorker',
  Sociologist = 'Sociologist',
  SportBroadcaster = 'SportBroadcaster',
  SubwayLightOperator = 'SubwayLightOperator',
  Superintendent = 'Superintendent',
  Supervisor = 'Supervisor',
  SupportServices = 'SupportServices',
  SupportTechnician = 'SupportTechnician',
  Surveyor = 'Surveyor',
  SystemsSecurity = 'SystemsSecurity',
  TailorSewer = 'TailorSewer',
  TeacherCollege = 'TeacherCollege',
  TeacherK12 = 'TeacherK12',
  TeachingAssistant = 'TeachingAssistant',
  TechnicalWriter = 'TechnicalWriter',
  Technician = 'Technician',
  TextileWorker = 'TextileWorker',
  Therapist = 'Therapist',
  TicketAgent = 'TicketAgent',
  TicketSales = 'TicketSales',
  TimberGrader = 'TimberGrader',
  Trader = 'Trader',
  Trainer = 'Trainer',
  TransportationSpecialist = 'TransportationSpecialist',
  Tutor = 'Tutor',
  UmpireReferee = 'UmpireReferee',
  Undergraduate = 'Undergraduate',
  Underwriter = 'Underwriter',
  Unemployed = 'Unemployed',
  Upholsterer = 'Upholsterer',
  UsPostalWorker = 'UsPostalWorker',
  Valet = 'Valet',
  Veterinarian = 'Veterinarian',
  WaiterWaitress = 'WaiterWaitress',
  WebDeveloper = 'WebDeveloper',
  WineSteward = 'WineSteward'
}

export type Organization = {
  __typename?: 'Organization';
  adhocBindEnabled: Scalars['Boolean']['output'];
  amsEnabled: Scalars['Boolean']['output'];
  amsForGatorEnabled: Scalars['Boolean']['output'];
  amsForSalesforceEnabled: Scalars['Boolean']['output'];
  appointments: Array<Appointment>;
  authToken?: Maybe<Scalars['String']['output']>;
  carrierTimeoutMessageEnabled: Scalars['Boolean']['output'];
  code?: Maybe<Scalars['String']['output']>;
  crmAllowAddProducts: Scalars['Boolean']['output'];
  displayErrorsOnUi: Scalars['Boolean']['output'];
  enableAutoQuoteDocDownload: Scalars['Boolean']['output'];
  enableHomeQuoteDocDownload: Scalars['Boolean']['output'];
  feedbackEnabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isVeriskPrefillAvailable: Scalars['Boolean']['output'];
  lob: OrganizationSupportedLob;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  propertyConsumerId?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
};

export type OrganizationSupportedHomeProducts = {
  __typename?: 'OrganizationSupportedHomeProducts';
  DP1?: Maybe<Scalars['Boolean']['output']>;
  DP3?: Maybe<Scalars['Boolean']['output']>;
  HO3?: Maybe<Scalars['Boolean']['output']>;
  HO4?: Maybe<Scalars['Boolean']['output']>;
  HO5?: Maybe<Scalars['Boolean']['output']>;
  HO6?: Maybe<Scalars['Boolean']['output']>;
  PUP?: Maybe<Scalars['Boolean']['output']>;
};

export type OrganizationSupportedLob = {
  __typename?: 'OrganizationSupportedLob';
  auto?: Maybe<Scalars['Boolean']['output']>;
  cyberSecurity?: Maybe<Scalars['Boolean']['output']>;
  earthquake?: Maybe<Scalars['Boolean']['output']>;
  flood?: Maybe<Scalars['Boolean']['output']>;
  home?: Maybe<OrganizationSupportedHomeProducts>;
  homeWarranty?: Maybe<Scalars['Boolean']['output']>;
  life?: Maybe<Scalars['Boolean']['output']>;
  pet?: Maybe<Scalars['Boolean']['output']>;
  umbrella?: Maybe<Scalars['Boolean']['output']>;
};

export type Ppc = {
  __typename?: 'PPC';
  protectionClass?: Maybe<Scalars['String']['output']>;
  protectionClassISOAAIS?: Maybe<ProtectionClassIsoaais>;
};

export type PageTracking = {
  __typename?: 'PageTracking';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PageTrackingInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum PoolInstallation {
  AboveGround = 'AboveGround',
  InGround = 'InGround'
}

export enum ProductName {
  Dp1 = 'Dp1',
  Dp3 = 'Dp3',
  Ho3 = 'Ho3',
  Ho4 = 'Ho4',
  Ho5 = 'Ho5',
  Ho6 = 'Ho6',
  Pup = 'Pup'
}

export type PropertyAdjustments = {
  __typename?: 'PropertyAdjustments';
  coverage: PropertyCoverage;
  deductible: PropertyDeductible;
};

export type PropertyAdjustmentsInput = {
  productName: ProductName;
  propertyId: Scalars['String']['input'];
  propertyRevision: Scalars['Int']['input'];
};

export type PropertyCoverage = {
  __typename?: 'PropertyCoverage';
  coverageA?: Maybe<Scalars['Float']['output']>;
  coverageB?: Maybe<Scalars['Float']['output']>;
  coverageC?: Maybe<Scalars['Float']['output']>;
  coverageD?: Maybe<Scalars['Float']['output']>;
  coverageE?: Maybe<Scalars['Float']['output']>;
  coverageF?: Maybe<Scalars['Float']['output']>;
  coverageL?: Maybe<Scalars['Float']['output']>;
  coverageM?: Maybe<Scalars['Float']['output']>;
  personalComputer?: Maybe<Scalars['Float']['output']>;
  personalPropertyReplacement?: Maybe<Scalars['Float']['output']>;
  waterBackup?: Maybe<Scalars['Float']['output']>;
};

export type PropertyData = {
  __typename?: 'PropertyData';
  address?: Maybe<Address>;
  addressId: Scalars['String']['output'];
  building?: Maybe<Building>;
  homeowner?: Maybe<Homeowner>;
  location?: Maybe<Location>;
  propertyId: Scalars['ID']['output'];
  rebuildingCost?: Maybe<RebuildingCost>;
  revision: Scalars['Float']['output'];
  risk?: Maybe<Risk>;
  site?: Maybe<Site>;
};

export type PropertyDataCreateErrors = {
  __typename?: 'PropertyDataCreateErrors';
  location?: Maybe<Scalars['String']['output']>;
  valuation?: Maybe<Scalars['String']['output']>;
};

export type PropertyDataCreated = {
  __typename?: 'PropertyDataCreated';
  address?: Maybe<Address>;
  addressId: Scalars['String']['output'];
  building?: Maybe<Building>;
  errors?: Maybe<PropertyDataCreateErrors>;
  homeowner?: Maybe<Homeowner>;
  location?: Maybe<Location>;
  propertyId: Scalars['ID']['output'];
  rebuildingCost?: Maybe<RebuildingCost>;
  revision: Scalars['Float']['output'];
  risk?: Maybe<Risk>;
  site?: Maybe<Site>;
};

export type PropertyDeductible = {
  __typename?: 'PropertyDeductible';
  base?: Maybe<Scalars['Float']['output']>;
  earthquake?: Maybe<Scalars['Float']['output']>;
  hurricane?: Maybe<Scalars['Float']['output']>;
  theft?: Maybe<Scalars['Float']['output']>;
  wind?: Maybe<Scalars['Float']['output']>;
  windHail?: Maybe<Scalars['Float']['output']>;
  windHailExcluded?: Maybe<Scalars['Boolean']['output']>;
};

export enum ProtectionClassIsoaais {
  PartiallyProtected1 = 'PartiallyProtected1',
  PartiallyProtected2 = 'PartiallyProtected2',
  PartiallyProtected3 = 'PartiallyProtected3',
  PartiallyProtected4 = 'PartiallyProtected4',
  PartiallyProtected5 = 'PartiallyProtected5',
  Protected1 = 'Protected1',
  Protected2 = 'Protected2',
  Protected3 = 'Protected3',
  Protected4 = 'Protected4',
  Protected5 = 'Protected5',
  Unprotected6 = 'Unprotected6',
  Unprotected7 = 'Unprotected7',
  Unprotected8 = 'Unprotected8',
  Unprotected9 = 'Unprotected9',
  Unprotected10 = 'Unprotected10',
  Unprotected15 = 'Unprotected15',
  Unprotected20 = 'Unprotected20',
  Unprotected25 = 'Unprotected25',
  Unprotected30 = 'Unprotected30',
  Unprotected35 = 'Unprotected35',
  Unprotected40 = 'Unprotected40',
  Unprotected45 = 'Unprotected45',
  Unprotected45Plus = 'Unprotected45Plus',
  '1' = '_1',
  '1X' = '_1X',
  '1Y' = '_1Y',
  '2' = '_2',
  '2X' = '_2X',
  '2Y' = '_2Y',
  '3' = '_3',
  '3X' = '_3X',
  '3Y' = '_3Y',
  '4' = '_4',
  '4X' = '_4X',
  '4Y' = '_4Y',
  '5' = '_5',
  '5X' = '_5X',
  '5Y' = '_5Y',
  '6' = '_6',
  '6X' = '_6X',
  '6Y' = '_6Y',
  '7' = '_7',
  '7X' = '_7X',
  '7Y' = '_7Y',
  '8' = '_8',
  '8A' = '_8A',
  '8B' = '_8B',
  '8X' = '_8X',
  '8Y' = '_8Y',
  '9' = '_9',
  '9A' = '_9A',
  '9B' = '_9B',
  '10' = '_10',
  '10C' = '_10C',
  '10W' = '_10W'
}

export enum PurchaseType {
  Offline = 'Offline',
  Online = 'Online'
}

export type Query = {
  __typename?: 'Query';
  address: Address;
  appointments: Array<Appointment>;
  homeQuoteRequest: HomeQuoteRequest;
  homeQuoteRequestPoll: HomeQuoteRequestPoll;
  organization: Organization;
  propertyAdjustments: PropertyAdjustments;
  propertyData: PropertyData;
};


export type QueryAddressArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHomeQuoteRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHomeQuoteRequestPollArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPropertyAdjustmentsArgs = {
  input: PropertyAdjustmentsInput;
};


export type QueryPropertyDataArgs = {
  propertyId: Scalars['ID']['input'];
  revision: Scalars['Int']['input'];
};

export enum QuoteCarrierErrorCategory {
  AddressableCarrierError = 'AddressableCarrierError',
  AgentAddressable = 'AgentAddressable',
  AgentAddressableCoveragesAndDeductibles = 'AgentAddressableCoveragesAndDeductibles',
  AgentAddressableCustomerData = 'AgentAddressableCustomerData',
  AgentAddressableProperty = 'AgentAddressableProperty',
  ApplicationError = 'ApplicationError',
  ApplicationErrorConfiguration = 'ApplicationErrorConfiguration',
  ApplicationErrorExternal = 'ApplicationErrorExternal',
  ApplicationErrorInternal = 'ApplicationErrorInternal',
  NonAddressableCarrierError = 'NonAddressableCarrierError',
  UnableToCategorize = 'UnableToCategorize',
  UnderwritingExposureManagement = 'UnderwritingExposureManagement',
  UnderwritingPropertyRisk = 'UnderwritingPropertyRisk'
}

export enum QuoteErrorType {
  Carrier = 'Carrier',
  Prefill = 'Prefill',
  PrefillInvalidAddress = 'PrefillInvalidAddress',
  PrefillNotFound = 'PrefillNotFound',
  PrefillTimeout = 'PrefillTimeout',
  Submit = 'Submit'
}

export type QuoteRequestBy = {
  __typename?: 'QuoteRequestBy';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuoteRequestByInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export enum QuoteRequestMethod {
  Api = 'Api',
  Bulk = 'Bulk',
  Crm = 'Crm',
  Hcr = 'Hcr',
  Single = 'Single'
}

export enum QuoteRequestStatus {
  Bound = 'Bound',
  Complete = 'Complete',
  Created = 'Created',
  InProgress = 'InProgress'
}

export enum QuoteRequestType {
  Consumer = 'Consumer',
  Producer = 'Producer'
}

export type RebuildingCost = {
  __typename?: 'RebuildingCost';
  hippo?: Maybe<HippoRebuildingCost>;
  verisk?: Maybe<VeriskRebuildingCost>;
};

export enum ResidenceType {
  Primary = 'Primary',
  Rented = 'Rented',
  Secondary = 'Secondary',
  Vacant = 'Vacant'
}

export type Risk = {
  __typename?: 'Risk';
  ppc?: Maybe<Ppc>;
};

export type Roof = {
  __typename?: 'Roof';
  material?: Maybe<RoofMaterial>;
  style?: Maybe<RoofStyle>;
  yearBuilt?: Maybe<Scalars['Int']['output']>;
};

export enum RoofMaterial {
  ArchitecturalAsphaltShingles = 'ArchitecturalAsphaltShingles',
  AsphaltMembrane = 'AsphaltMembrane',
  BasicAsphaltShingles = 'BasicAsphaltShingles',
  BasicMetal = 'BasicMetal',
  BuiltUp = 'BuiltUp',
  CementFiberTile = 'CementFiberTile',
  ClayTile = 'ClayTile',
  CompositeShingles = 'CompositeShingles',
  ConcreteTile = 'ConcreteTile',
  CopperOrOtherPremiumMetal = 'CopperOrOtherPremiumMetal',
  Foam = 'Foam',
  ImpactResistantAsphaltShingles = 'ImpactResistantAsphaltShingles',
  PlasticMembrane = 'PlasticMembrane',
  SlateTile = 'SlateTile',
  WoodShingles = 'WoodShingles'
}

export enum RoofStyle {
  Custom = 'Custom',
  Flat = 'Flat',
  Gable = 'Gable',
  Gambrel = 'Gambrel',
  Hip = 'Hip',
  Mansard = 'Mansard',
  Shed = 'Shed'
}

export type Site = {
  __typename?: 'Site';
  hasSecurityGuard?: Maybe<Scalars['Boolean']['output']>;
  hasSwimmingPool?: Maybe<Scalars['Boolean']['output']>;
  hasTrampoline?: Maybe<Scalars['Boolean']['output']>;
  swimmingPool?: Maybe<SwimmingPool>;
};

export type Stall = {
  __typename?: 'Stall';
  count?: Maybe<Scalars['Float']['output']>;
};

export enum StateName {
  Ak = 'Ak',
  Al = 'Al',
  Ar = 'Ar',
  Az = 'Az',
  Ca = 'Ca',
  Co = 'Co',
  Ct = 'Ct',
  Dc = 'Dc',
  De = 'De',
  Fl = 'Fl',
  Ga = 'Ga',
  Hi = 'Hi',
  Ia = 'Ia',
  Id = 'Id',
  Il = 'Il',
  In = 'In',
  Ks = 'Ks',
  Ky = 'Ky',
  La = 'La',
  Ma = 'Ma',
  Md = 'Md',
  Me = 'Me',
  Mi = 'Mi',
  Mn = 'Mn',
  Mo = 'Mo',
  Ms = 'Ms',
  Mt = 'Mt',
  Nc = 'Nc',
  Nd = 'Nd',
  Ne = 'Ne',
  Nh = 'Nh',
  Nj = 'Nj',
  Nm = 'Nm',
  Nv = 'Nv',
  Ny = 'Ny',
  Oh = 'Oh',
  Ok = 'Ok',
  Or = 'Or',
  Pa = 'Pa',
  Pr = 'Pr',
  Ri = 'Ri',
  Sc = 'Sc',
  Sd = 'Sd',
  Tn = 'Tn',
  Tx = 'Tx',
  Ut = 'Ut',
  Va = 'Va',
  Vi = 'Vi',
  Vt = 'Vt',
  Wa = 'Wa',
  Wi = 'Wi',
  Wv = 'Wv',
  Wy = 'Wy'
}

export enum Stories {
  BiLevel = 'BiLevel',
  Four = 'Four',
  One = 'One',
  OneAndAHalf = 'OneAndAHalf',
  SplitLevel = 'SplitLevel',
  Three = 'Three',
  ThreeAndAHalf = 'ThreeAndAHalf',
  Two = 'Two',
  TwoAndAHalf = 'TwoAndAHalf'
}

export type SwimmingPool = {
  __typename?: 'SwimmingPool';
  hasSlide?: Maybe<Scalars['Boolean']['output']>;
  installation?: Maybe<Scalars['String']['output']>;
  isFenced?: Maybe<Scalars['Boolean']['output']>;
};

export enum TermLabel {
  Annually = 'Annually',
  HalfYearly = 'HalfYearly'
}

export type UnderwritingMessageData = {
  __typename?: 'UnderwritingMessageData';
  message: Scalars['String']['output'];
};

export type UpdateBasementInput = {
  finishedPercent?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateBathroomInput = {
  full?: InputMaybe<UpdateFullBathroomInput>;
  half?: InputMaybe<UpdateHalfBathroomInput>;
};

export type UpdateBedroomInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateBuildingInput = {
  exteriorWall?: InputMaybe<UpdateExteriorWallInput>;
  foundation?: InputMaybe<UpdateFoundationInput>;
  garage?: InputMaybe<UpdateGarageInput>;
  general?: InputMaybe<UpdateGeneralInput>;
  interior?: InputMaybe<UpdateInteriorInput>;
  roof?: InputMaybe<UpdateRoofInput>;
  utility?: InputMaybe<UpdateUtilityInput>;
};

export type UpdateExteriorWallInput = {
  finish?: InputMaybe<ExteriorWallFinish>;
  structure?: InputMaybe<ExteriorWallStructure>;
};

export type UpdateFireplaceInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateFoundationInput = {
  basement?: InputMaybe<UpdateBasementInput>;
  slope?: InputMaybe<FoundationSlope>;
  type?: InputMaybe<FoundationType>;
};

export type UpdateFullBathroomInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateGarageInput = {
  stall?: InputMaybe<UpdateStallInput>;
  type?: InputMaybe<GarageType>;
};

export type UpdateGeneralInput = {
  attachedness?: InputMaybe<Attachedness>;
  condition?: InputMaybe<BuildingCondition>;
  constructionStyle?: InputMaybe<ConstructionStyle>;
  familyUnits?: InputMaybe<FamilyUnits>;
  quality?: InputMaybe<BuildingQuality>;
  squareFootage?: InputMaybe<Scalars['Float']['input']>;
  stories?: InputMaybe<Stories>;
  yearBuilt?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateHalfBathroomInput = {
  count?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateHippoRebuildingCostInput = {
  medium?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateHomeCoverageInput = {
  coverageA?: InputMaybe<Scalars['Float']['input']>;
  coverageB?: InputMaybe<Scalars['Float']['input']>;
  coverageC?: InputMaybe<Scalars['Float']['input']>;
  coverageD?: InputMaybe<Scalars['Float']['input']>;
  coverageE?: InputMaybe<Scalars['Float']['input']>;
  coverageF?: InputMaybe<Scalars['Float']['input']>;
  coverageL?: InputMaybe<Scalars['Float']['input']>;
  coverageM?: InputMaybe<Scalars['Float']['input']>;
  personalComputer?: InputMaybe<Scalars['Float']['input']>;
  personalPropertyReplacement?: InputMaybe<Scalars['Float']['input']>;
  waterBackup?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateHomeDeductibleInput = {
  base?: InputMaybe<Scalars['Float']['input']>;
  earthquake?: InputMaybe<Scalars['Float']['input']>;
  hurricane?: InputMaybe<Scalars['Float']['input']>;
  theft?: InputMaybe<Scalars['Float']['input']>;
  wind?: InputMaybe<Scalars['Float']['input']>;
  windHail?: InputMaybe<Scalars['Float']['input']>;
  windHailExcluded?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateHomeQuoteRequestInput = {
  applicant?: InputMaybe<HomeApplicantInput>;
  coverage?: InputMaybe<UpdateHomeCoverageInput>;
  deductible?: InputMaybe<UpdateHomeDeductibleInput>;
  pageTracking?: InputMaybe<Array<PageTrackingInput>>;
  productName?: InputMaybe<ProductName>;
  propertyId?: InputMaybe<Scalars['String']['input']>;
  propertyRevision?: InputMaybe<Scalars['Int']['input']>;
  residenceType?: InputMaybe<ResidenceType>;
  selectedLob?: InputMaybe<Array<LineOfBusiness>>;
};

export type UpdateHomeownerInput = {
  hasBeenVacantForAtLeast90Days?: InputMaybe<Scalars['Boolean']['input']>;
  isLastForeclosureForCurrentOwner?: InputMaybe<Scalars['Boolean']['input']>;
  lastForeclosureDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastPurchaseDate?: InputMaybe<Scalars['DateTime']['input']>;
  lastPurchasePrice?: InputMaybe<Scalars['Float']['input']>;
  marketValue?: InputMaybe<Scalars['Float']['input']>;
  numberOfOpenMortgages?: InputMaybe<Scalars['Int']['input']>;
  ownerIsLLC?: InputMaybe<Scalars['Boolean']['input']>;
  ownerIsTrust?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateInteriorInput = {
  bathrooms?: InputMaybe<UpdateBathroomInput>;
  bedrooms?: InputMaybe<UpdateBedroomInput>;
  fireplace?: InputMaybe<UpdateFireplaceInput>;
  hasBurglarAlarm?: InputMaybe<Scalars['Boolean']['input']>;
  hasDeadbolt?: InputMaybe<Scalars['Boolean']['input']>;
  hasFireAlarm?: InputMaybe<Scalars['Boolean']['input']>;
  hasFireExtinguisher?: InputMaybe<Scalars['Boolean']['input']>;
  hasFireSprinkler?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateLocationInput = {
  distanceToCoast?: InputMaybe<Scalars['Float']['input']>;
  distanceToFireStation?: InputMaybe<Scalars['Float']['input']>;
  distanceToWater?: InputMaybe<Scalars['Float']['input']>;
  feetToNearestHydrant?: InputMaybe<FeetToNearestHydrant>;
  withinCityLimit?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePpcInput = {
  protectionClass?: InputMaybe<Scalars['String']['input']>;
  protectionClassISOAAIS?: InputMaybe<ProtectionClassIsoaais>;
};

export type UpdatePropertyInput = {
  building?: InputMaybe<UpdateBuildingInput>;
  homeowner?: InputMaybe<UpdateHomeownerInput>;
  location?: InputMaybe<UpdateLocationInput>;
  site?: InputMaybe<UpdateSiteInput>;
};

export type UpdateRebuildingCostInput = {
  hippo?: InputMaybe<UpdateHippoRebuildingCostInput>;
  verisk?: InputMaybe<UpdateVeriskRebuildingCostInput>;
};

export type UpdateRiskInput = {
  ppc?: InputMaybe<UpdatePpcInput>;
};

export type UpdateRoofInput = {
  material?: InputMaybe<RoofMaterial>;
  style?: InputMaybe<RoofStyle>;
  yearBuilt?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSiteInput = {
  hasSecurityGuard?: InputMaybe<Scalars['Boolean']['input']>;
  hasSwimmingPool?: InputMaybe<Scalars['Boolean']['input']>;
  hasTrampoline?: InputMaybe<Scalars['Boolean']['input']>;
  swimmingPool?: InputMaybe<UpdateSwimmingPoolInput>;
};

export type UpdateStallInput = {
  count?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateSwimmingPoolInput = {
  hasSlide?: InputMaybe<Scalars['Boolean']['input']>;
  installation?: InputMaybe<PoolInstallation>;
  isFenced?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUtilityInput = {
  electricYearUpdated?: InputMaybe<Scalars['Int']['input']>;
  heatingYearUpdated?: InputMaybe<Scalars['Int']['input']>;
  plumbingYearUpdated?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateVeriskRebuildingCostInput = {
  avgRebuildingCostPerSqFt?: InputMaybe<Scalars['Float']['input']>;
  high?: InputMaybe<Scalars['Float']['input']>;
  low?: InputMaybe<Scalars['Float']['input']>;
  medium?: InputMaybe<Scalars['Float']['input']>;
  minRebuildingCostPerSqFt?: InputMaybe<Scalars['Float']['input']>;
};

export type Utility = {
  __typename?: 'Utility';
  electricYearUpdated?: Maybe<Scalars['Int']['output']>;
  heatingYearUpdated?: Maybe<Scalars['Int']['output']>;
  plumbingYearUpdated?: Maybe<Scalars['Int']['output']>;
};

export type VeriskRebuildingCost = {
  __typename?: 'VeriskRebuildingCost';
  avgRebuildingCostPerSqFt?: Maybe<Scalars['Float']['output']>;
  high?: Maybe<Scalars['Float']['output']>;
  low?: Maybe<Scalars['Float']['output']>;
  medium?: Maybe<Scalars['Float']['output']>;
  minRebuildingCostPerSqFt?: Maybe<Scalars['Float']['output']>;
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  Address: ResolverTypeWrapper<Address>;
  Appointment: ResolverTypeWrapper<Appointment>;
  AppointmentIntegrationType: AppointmentIntegrationType;
  Attachedness: Attachedness;
  Basement: ResolverTypeWrapper<Basement>;
  Bathroom: ResolverTypeWrapper<Bathroom>;
  Bedroom: ResolverTypeWrapper<Bedroom>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Building: ResolverTypeWrapper<Building>;
  BuildingCondition: BuildingCondition;
  BuildingQuality: BuildingQuality;
  ConstructionStyle: ConstructionStyle;
  CreateAddressInput: CreateAddressInput;
  CreateHomeQuoteRequestInput: CreateHomeQuoteRequestInput;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  Education: Education;
  ErrorStatus: ErrorStatus;
  ExteriorWall: ResolverTypeWrapper<ExteriorWall>;
  ExteriorWallFinish: ExteriorWallFinish;
  ExteriorWallStructure: ExteriorWallStructure;
  FamilyUnits: FamilyUnits;
  FeetToNearestHydrant: FeetToNearestHydrant;
  Fireplace: ResolverTypeWrapper<Fireplace>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  Foundation: ResolverTypeWrapper<Foundation>;
  FoundationSlope: FoundationSlope;
  FoundationType: FoundationType;
  FullBathroom: ResolverTypeWrapper<FullBathroom>;
  Garage: ResolverTypeWrapper<Garage>;
  GarageType: GarageType;
  General: ResolverTypeWrapper<General>;
  HalfBathroom: ResolverTypeWrapper<HalfBathroom>;
  HippoRebuildingCost: ResolverTypeWrapper<HippoRebuildingCost>;
  HomeApplicant: ResolverTypeWrapper<HomeApplicant>;
  HomeApplicantInput: HomeApplicantInput;
  HomeQuote: ResolverTypeWrapper<HomeQuote>;
  HomeQuoteData: ResolverTypeWrapper<HomeQuoteData>;
  HomeQuoteError: ResolverTypeWrapper<HomeQuoteError>;
  HomeQuotePending: ResolverTypeWrapper<HomeQuotePending>;
  HomeQuoteRequest: ResolverTypeWrapper<HomeQuoteRequest>;
  HomeQuoteRequestPoll: ResolverTypeWrapper<HomeQuoteRequestPoll>;
  HomeUpcomingCarrier: ResolverTypeWrapper<HomeUpcomingCarrier>;
  Homeowner: ResolverTypeWrapper<Homeowner>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Industry: Industry;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  Interior: ResolverTypeWrapper<Interior>;
  JSONObject: ResolverTypeWrapper<Scalars['JSONObject']['output']>;
  LineOfBusiness: LineOfBusiness;
  Location: ResolverTypeWrapper<Location>;
  MaritalStatus: MaritalStatus;
  Mutation: ResolverTypeWrapper<{}>;
  Occupation: Occupation;
  Organization: ResolverTypeWrapper<Organization>;
  OrganizationSupportedHomeProducts: ResolverTypeWrapper<OrganizationSupportedHomeProducts>;
  OrganizationSupportedLob: ResolverTypeWrapper<OrganizationSupportedLob>;
  PPC: ResolverTypeWrapper<Ppc>;
  PageTracking: ResolverTypeWrapper<PageTracking>;
  PageTrackingInput: PageTrackingInput;
  PoolInstallation: PoolInstallation;
  ProductName: ProductName;
  PropertyAdjustments: ResolverTypeWrapper<PropertyAdjustments>;
  PropertyAdjustmentsInput: PropertyAdjustmentsInput;
  PropertyCoverage: ResolverTypeWrapper<PropertyCoverage>;
  PropertyData: ResolverTypeWrapper<PropertyData>;
  PropertyDataCreateErrors: ResolverTypeWrapper<PropertyDataCreateErrors>;
  PropertyDataCreated: ResolverTypeWrapper<PropertyDataCreated>;
  PropertyDeductible: ResolverTypeWrapper<PropertyDeductible>;
  ProtectionClassISOAAIS: ProtectionClassIsoaais;
  PurchaseType: PurchaseType;
  Query: ResolverTypeWrapper<{}>;
  QuoteCarrierErrorCategory: QuoteCarrierErrorCategory;
  QuoteErrorType: QuoteErrorType;
  QuoteRequestBy: ResolverTypeWrapper<QuoteRequestBy>;
  QuoteRequestByInput: QuoteRequestByInput;
  QuoteRequestMethod: QuoteRequestMethod;
  QuoteRequestStatus: QuoteRequestStatus;
  QuoteRequestType: QuoteRequestType;
  RebuildingCost: ResolverTypeWrapper<RebuildingCost>;
  ResidenceType: ResidenceType;
  Risk: ResolverTypeWrapper<Risk>;
  Roof: ResolverTypeWrapper<Roof>;
  RoofMaterial: RoofMaterial;
  RoofStyle: RoofStyle;
  Site: ResolverTypeWrapper<Site>;
  Stall: ResolverTypeWrapper<Stall>;
  StateName: StateName;
  Stories: Stories;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  SwimmingPool: ResolverTypeWrapper<SwimmingPool>;
  TermLabel: TermLabel;
  UnderwritingMessageData: ResolverTypeWrapper<UnderwritingMessageData>;
  UpdateBasementInput: UpdateBasementInput;
  UpdateBathroomInput: UpdateBathroomInput;
  UpdateBedroomInput: UpdateBedroomInput;
  UpdateBuildingInput: UpdateBuildingInput;
  UpdateExteriorWallInput: UpdateExteriorWallInput;
  UpdateFireplaceInput: UpdateFireplaceInput;
  UpdateFoundationInput: UpdateFoundationInput;
  UpdateFullBathroomInput: UpdateFullBathroomInput;
  UpdateGarageInput: UpdateGarageInput;
  UpdateGeneralInput: UpdateGeneralInput;
  UpdateHalfBathroomInput: UpdateHalfBathroomInput;
  UpdateHippoRebuildingCostInput: UpdateHippoRebuildingCostInput;
  UpdateHomeCoverageInput: UpdateHomeCoverageInput;
  UpdateHomeDeductibleInput: UpdateHomeDeductibleInput;
  UpdateHomeQuoteRequestInput: UpdateHomeQuoteRequestInput;
  UpdateHomeownerInput: UpdateHomeownerInput;
  UpdateInteriorInput: UpdateInteriorInput;
  UpdateLocationInput: UpdateLocationInput;
  UpdatePPCInput: UpdatePpcInput;
  UpdatePropertyInput: UpdatePropertyInput;
  UpdateRebuildingCostInput: UpdateRebuildingCostInput;
  UpdateRiskInput: UpdateRiskInput;
  UpdateRoofInput: UpdateRoofInput;
  UpdateSiteInput: UpdateSiteInput;
  UpdateStallInput: UpdateStallInput;
  UpdateSwimmingPoolInput: UpdateSwimmingPoolInput;
  UpdateUtilityInput: UpdateUtilityInput;
  UpdateVeriskRebuildingCostInput: UpdateVeriskRebuildingCostInput;
  Utility: ResolverTypeWrapper<Utility>;
  VeriskRebuildingCost: ResolverTypeWrapper<VeriskRebuildingCost>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  Address: Address;
  Appointment: Appointment;
  Basement: Basement;
  Bathroom: Bathroom;
  Bedroom: Bedroom;
  Boolean: Scalars['Boolean']['output'];
  Building: Building;
  CreateAddressInput: CreateAddressInput;
  CreateHomeQuoteRequestInput: CreateHomeQuoteRequestInput;
  DateTime: Scalars['DateTime']['output'];
  ExteriorWall: ExteriorWall;
  Fireplace: Fireplace;
  Float: Scalars['Float']['output'];
  Foundation: Foundation;
  FullBathroom: FullBathroom;
  Garage: Garage;
  General: General;
  HalfBathroom: HalfBathroom;
  HippoRebuildingCost: HippoRebuildingCost;
  HomeApplicant: HomeApplicant;
  HomeApplicantInput: HomeApplicantInput;
  HomeQuote: HomeQuote;
  HomeQuoteData: HomeQuoteData;
  HomeQuoteError: HomeQuoteError;
  HomeQuotePending: HomeQuotePending;
  HomeQuoteRequest: HomeQuoteRequest;
  HomeQuoteRequestPoll: HomeQuoteRequestPoll;
  HomeUpcomingCarrier: HomeUpcomingCarrier;
  Homeowner: Homeowner;
  ID: Scalars['ID']['output'];
  Int: Scalars['Int']['output'];
  Interior: Interior;
  JSONObject: Scalars['JSONObject']['output'];
  Location: Location;
  Mutation: {};
  Organization: Organization;
  OrganizationSupportedHomeProducts: OrganizationSupportedHomeProducts;
  OrganizationSupportedLob: OrganizationSupportedLob;
  PPC: Ppc;
  PageTracking: PageTracking;
  PageTrackingInput: PageTrackingInput;
  PropertyAdjustments: PropertyAdjustments;
  PropertyAdjustmentsInput: PropertyAdjustmentsInput;
  PropertyCoverage: PropertyCoverage;
  PropertyData: PropertyData;
  PropertyDataCreateErrors: PropertyDataCreateErrors;
  PropertyDataCreated: PropertyDataCreated;
  PropertyDeductible: PropertyDeductible;
  Query: {};
  QuoteRequestBy: QuoteRequestBy;
  QuoteRequestByInput: QuoteRequestByInput;
  RebuildingCost: RebuildingCost;
  Risk: Risk;
  Roof: Roof;
  Site: Site;
  Stall: Stall;
  String: Scalars['String']['output'];
  SwimmingPool: SwimmingPool;
  UnderwritingMessageData: UnderwritingMessageData;
  UpdateBasementInput: UpdateBasementInput;
  UpdateBathroomInput: UpdateBathroomInput;
  UpdateBedroomInput: UpdateBedroomInput;
  UpdateBuildingInput: UpdateBuildingInput;
  UpdateExteriorWallInput: UpdateExteriorWallInput;
  UpdateFireplaceInput: UpdateFireplaceInput;
  UpdateFoundationInput: UpdateFoundationInput;
  UpdateFullBathroomInput: UpdateFullBathroomInput;
  UpdateGarageInput: UpdateGarageInput;
  UpdateGeneralInput: UpdateGeneralInput;
  UpdateHalfBathroomInput: UpdateHalfBathroomInput;
  UpdateHippoRebuildingCostInput: UpdateHippoRebuildingCostInput;
  UpdateHomeCoverageInput: UpdateHomeCoverageInput;
  UpdateHomeDeductibleInput: UpdateHomeDeductibleInput;
  UpdateHomeQuoteRequestInput: UpdateHomeQuoteRequestInput;
  UpdateHomeownerInput: UpdateHomeownerInput;
  UpdateInteriorInput: UpdateInteriorInput;
  UpdateLocationInput: UpdateLocationInput;
  UpdatePPCInput: UpdatePpcInput;
  UpdatePropertyInput: UpdatePropertyInput;
  UpdateRebuildingCostInput: UpdateRebuildingCostInput;
  UpdateRiskInput: UpdateRiskInput;
  UpdateRoofInput: UpdateRoofInput;
  UpdateSiteInput: UpdateSiteInput;
  UpdateStallInput: UpdateStallInput;
  UpdateSwimmingPoolInput: UpdateSwimmingPoolInput;
  UpdateUtilityInput: UpdateUtilityInput;
  UpdateVeriskRebuildingCostInput: UpdateVeriskRebuildingCostInput;
  Utility: Utility;
  VeriskRebuildingCost: VeriskRebuildingCost;
};

export type AddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['Address'] = ResolversParentTypes['Address']> = {
  city?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  county?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fiveDigitZipcode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['StateName'], ParentType, ContextType>;
  street?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  street2?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  zipcode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppointmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Appointment'] = ResolversParentTypes['Appointment']> = {
  consumerMarket?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  integrationType?: Resolver<Maybe<ResolversTypes['AppointmentIntegrationType']>, ParentType, ContextType>;
  isActive?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isAvailableForQuoting?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isEnableForLeadFlow?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lob?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  market?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  organizationId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  products?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  updatedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  updatedBy?: Resolver<Maybe<ResolversTypes['JSONObject']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BasementResolvers<ContextType = any, ParentType extends ResolversParentTypes['Basement'] = ResolversParentTypes['Basement']> = {
  finishedPercent?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BathroomResolvers<ContextType = any, ParentType extends ResolversParentTypes['Bathroom'] = ResolversParentTypes['Bathroom']> = {
  full?: Resolver<Maybe<ResolversTypes['FullBathroom']>, ParentType, ContextType>;
  half?: Resolver<Maybe<ResolversTypes['HalfBathroom']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BedroomResolvers<ContextType = any, ParentType extends ResolversParentTypes['Bedroom'] = ResolversParentTypes['Bedroom']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BuildingResolvers<ContextType = any, ParentType extends ResolversParentTypes['Building'] = ResolversParentTypes['Building']> = {
  exteriorWall?: Resolver<Maybe<ResolversTypes['ExteriorWall']>, ParentType, ContextType>;
  foundation?: Resolver<Maybe<ResolversTypes['Foundation']>, ParentType, ContextType>;
  garage?: Resolver<Maybe<ResolversTypes['Garage']>, ParentType, ContextType>;
  general?: Resolver<Maybe<ResolversTypes['General']>, ParentType, ContextType>;
  interior?: Resolver<Maybe<ResolversTypes['Interior']>, ParentType, ContextType>;
  roof?: Resolver<Maybe<ResolversTypes['Roof']>, ParentType, ContextType>;
  utility?: Resolver<Maybe<ResolversTypes['Utility']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type ExteriorWallResolvers<ContextType = any, ParentType extends ResolversParentTypes['ExteriorWall'] = ResolversParentTypes['ExteriorWall']> = {
  finish?: Resolver<Maybe<ResolversTypes['ExteriorWallFinish']>, ParentType, ContextType>;
  structure?: Resolver<Maybe<ResolversTypes['ExteriorWallStructure']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FireplaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['Fireplace'] = ResolversParentTypes['Fireplace']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FoundationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Foundation'] = ResolversParentTypes['Foundation']> = {
  basement?: Resolver<Maybe<ResolversTypes['Basement']>, ParentType, ContextType>;
  slope?: Resolver<Maybe<ResolversTypes['FoundationSlope']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['FoundationType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type FullBathroomResolvers<ContextType = any, ParentType extends ResolversParentTypes['FullBathroom'] = ResolversParentTypes['FullBathroom']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GarageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Garage'] = ResolversParentTypes['Garage']> = {
  stall?: Resolver<Maybe<ResolversTypes['Stall']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['GarageType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeneralResolvers<ContextType = any, ParentType extends ResolversParentTypes['General'] = ResolversParentTypes['General']> = {
  attachedness?: Resolver<Maybe<ResolversTypes['Attachedness']>, ParentType, ContextType>;
  condition?: Resolver<Maybe<ResolversTypes['BuildingCondition']>, ParentType, ContextType>;
  constructionStyle?: Resolver<Maybe<ResolversTypes['ConstructionStyle']>, ParentType, ContextType>;
  familyUnits?: Resolver<Maybe<ResolversTypes['FamilyUnits']>, ParentType, ContextType>;
  quality?: Resolver<Maybe<ResolversTypes['BuildingQuality']>, ParentType, ContextType>;
  squareFootage?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  stories?: Resolver<Maybe<ResolversTypes['Stories']>, ParentType, ContextType>;
  yearBuilt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HalfBathroomResolvers<ContextType = any, ParentType extends ResolversParentTypes['HalfBathroom'] = ResolversParentTypes['HalfBathroom']> = {
  count?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HippoRebuildingCostResolvers<ContextType = any, ParentType extends ResolversParentTypes['HippoRebuildingCost'] = ResolversParentTypes['HippoRebuildingCost']> = {
  medium?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HomeApplicantResolvers<ContextType = any, ParentType extends ResolversParentTypes['HomeApplicant'] = ResolversParentTypes['HomeApplicant']> = {
  dateOfBirth?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  education?: Resolver<ResolversTypes['Education'], ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  industry?: Resolver<ResolversTypes['Industry'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  maritalStatus?: Resolver<Maybe<ResolversTypes['MaritalStatus']>, ParentType, ContextType>;
  middleName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  occupation?: Resolver<ResolversTypes['Occupation'], ParentType, ContextType>;
  phone?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HomeQuoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['HomeQuote'] = ResolversParentTypes['HomeQuote']> = {
  carrierId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  carrierName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  data?: Resolver<Maybe<ResolversTypes['HomeQuoteData']>, ParentType, ContextType>;
  error?: Resolver<Maybe<ResolversTypes['HomeQuoteError']>, ParentType, ContextType>;
  logoUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  tooltip?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HomeQuoteDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['HomeQuoteData'] = ResolversParentTypes['HomeQuoteData']> = {
  agentUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  computers?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  covA?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  covALimitAdditional?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  covB?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  covC?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  covD?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  covE?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  covF?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  covL?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  covM?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  deductibles?: Resolver<ResolversTypes['PropertyDeductible'], ParentType, ContextType>;
  dicPresent?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  downPayment?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  equipmentBreakdown?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  equipmentBreakdownIncluded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  extendedReplacementCost?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  herdId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  homeOffice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  hvac?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isAdmitted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isMonthlyPremiumSupported?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  jewelry?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  licenseLink?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  link?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lossAssessment?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  monthlyPremium?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  mortgagePaymentProtection?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  numberOfMonthlyInstallments?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ordinanceOrLawProtection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personalProperty?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  personalPropertyReplacementCost?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  policyBounded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  price?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  product?: Resolver<ResolversTypes['ProductName'], ParentType, ContextType>;
  purchaseType?: Resolver<ResolversTypes['PurchaseType'], ParentType, ContextType>;
  quoteId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  quoteLicense?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  term?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  termLabel?: Resolver<Maybe<ResolversTypes['TermLabel']>, ParentType, ContextType>;
  underwritingMessage?: Resolver<Array<ResolversTypes['UnderwritingMessageData']>, ParentType, ContextType>;
  waterBackup?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HomeQuoteErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['HomeQuoteError'] = ResolversParentTypes['HomeQuoteError']> = {
  errorCategory?: Resolver<ResolversTypes['QuoteCarrierErrorCategory'], ParentType, ContextType>;
  errorStatus?: Resolver<ResolversTypes['ErrorStatus'], ParentType, ContextType>;
  errorType?: Resolver<Maybe<ResolversTypes['QuoteErrorType']>, ParentType, ContextType>;
  statusText?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HomeQuotePendingResolvers<ContextType = any, ParentType extends ResolversParentTypes['HomeQuotePending'] = ResolversParentTypes['HomeQuotePending']> = {
  carrierId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  carrierName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  logoUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HomeQuoteRequestResolvers<ContextType = any, ParentType extends ResolversParentTypes['HomeQuoteRequest'] = ResolversParentTypes['HomeQuoteRequest']> = {
  applicant?: Resolver<ResolversTypes['HomeApplicant'], ParentType, ContextType>;
  coverage?: Resolver<Maybe<ResolversTypes['PropertyCoverage']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  deductible?: Resolver<Maybe<ResolversTypes['PropertyDeductible']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  pageTracking?: Resolver<Maybe<Array<ResolversTypes['PageTracking']>>, ParentType, ContextType>;
  productName?: Resolver<ResolversTypes['ProductName'], ParentType, ContextType>;
  propertyData?: Resolver<ResolversTypes['PropertyData'], ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyRevision?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  quoteBy?: Resolver<ResolversTypes['QuoteRequestBy'], ParentType, ContextType>;
  quoteMethod?: Resolver<ResolversTypes['QuoteRequestMethod'], ParentType, ContextType>;
  quoteType?: Resolver<ResolversTypes['QuoteRequestType'], ParentType, ContextType>;
  referenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  residenceType?: Resolver<ResolversTypes['ResidenceType'], ParentType, ContextType>;
  selectedLob?: Resolver<Array<ResolversTypes['LineOfBusiness']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['QuoteRequestStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HomeQuoteRequestPollResolvers<ContextType = any, ParentType extends ResolversParentTypes['HomeQuoteRequestPoll'] = ResolversParentTypes['HomeQuoteRequestPoll']> = {
  continuePolling?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pendingQuotes?: Resolver<Array<ResolversTypes['HomeQuotePending']>, ParentType, ContextType>;
  quoteRequestStatus?: Resolver<ResolversTypes['QuoteRequestStatus'], ParentType, ContextType>;
  quotes?: Resolver<Array<ResolversTypes['HomeQuote']>, ParentType, ContextType>;
  upcomingCarriers?: Resolver<Array<ResolversTypes['HomeUpcomingCarrier']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HomeUpcomingCarrierResolvers<ContextType = any, ParentType extends ResolversParentTypes['HomeUpcomingCarrier'] = ResolversParentTypes['HomeUpcomingCarrier']> = {
  agentUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carrierId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  carrierName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  isActive?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isAvailableForQuoting?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  logoUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type HomeownerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Homeowner'] = ResolversParentTypes['Homeowner']> = {
  hasBeenVacantForAtLeast90Days?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  isLastForeclosureForCurrentOwner?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  lastForeclosureDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastPurchaseDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastPurchasePrice?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  marketValue?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  numberOfOpenMortgages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ownerIsLLC?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  ownerIsTrust?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type InteriorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Interior'] = ResolversParentTypes['Interior']> = {
  bathrooms?: Resolver<Maybe<ResolversTypes['Bathroom']>, ParentType, ContextType>;
  bedrooms?: Resolver<Maybe<ResolversTypes['Bedroom']>, ParentType, ContextType>;
  fireplace?: Resolver<Maybe<ResolversTypes['Fireplace']>, ParentType, ContextType>;
  hasBurglarAlarm?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasDeadbolt?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasFireAlarm?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasFireExtinguisher?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasFireSprinkler?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface JsonObjectScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSONObject'], any> {
  name: 'JSONObject';
}

export type LocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Location'] = ResolversParentTypes['Location']> = {
  distanceToCoast?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  distanceToFireStation?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  distanceToWater?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  feetToNearestHydrant?: Resolver<Maybe<ResolversTypes['FeetToNearestHydrant']>, ParentType, ContextType>;
  withinCityLimit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  createHomeQuoteRequest?: Resolver<Maybe<ResolversTypes['HomeQuoteRequest']>, ParentType, ContextType, RequireFields<MutationCreateHomeQuoteRequestArgs, 'input'>>;
  createPropertyData?: Resolver<ResolversTypes['PropertyDataCreated'], ParentType, ContextType, RequireFields<MutationCreatePropertyDataArgs, 'input'>>;
  executeQuoteRequest?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationExecuteQuoteRequestArgs, 'id'>>;
  updateHomeQuoteRequest?: Resolver<Maybe<ResolversTypes['HomeQuoteRequest']>, ParentType, ContextType, RequireFields<MutationUpdateHomeQuoteRequestArgs, 'id' | 'input'>>;
  updateProperty?: Resolver<ResolversTypes['PropertyData'], ParentType, ContextType, RequireFields<MutationUpdatePropertyArgs, 'input' | 'propertyId'>>;
};

export type OrganizationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Organization'] = ResolversParentTypes['Organization']> = {
  adhocBindEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  amsEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  amsForGatorEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  amsForSalesforceEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  appointments?: Resolver<Array<ResolversTypes['Appointment']>, ParentType, ContextType>;
  authToken?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  carrierTimeoutMessageEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  code?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  crmAllowAddProducts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  displayErrorsOnUi?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  enableAutoQuoteDocDownload?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  enableHomeQuoteDocDownload?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  feedbackEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isVeriskPrefillAvailable?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  lob?: Resolver<ResolversTypes['OrganizationSupportedLob'], ParentType, ContextType>;
  logoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  propertyConsumerId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  templateName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationSupportedHomeProductsResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationSupportedHomeProducts'] = ResolversParentTypes['OrganizationSupportedHomeProducts']> = {
  DP1?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  DP3?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  HO3?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  HO4?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  HO5?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  HO6?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  PUP?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OrganizationSupportedLobResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrganizationSupportedLob'] = ResolversParentTypes['OrganizationSupportedLob']> = {
  auto?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  cyberSecurity?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  earthquake?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  flood?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  home?: Resolver<Maybe<ResolversTypes['OrganizationSupportedHomeProducts']>, ParentType, ContextType>;
  homeWarranty?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  life?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pet?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  umbrella?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PpcResolvers<ContextType = any, ParentType extends ResolversParentTypes['PPC'] = ResolversParentTypes['PPC']> = {
  protectionClass?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  protectionClassISOAAIS?: Resolver<Maybe<ResolversTypes['ProtectionClassISOAAIS']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PageTrackingResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageTracking'] = ResolversParentTypes['PageTracking']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PropertyAdjustmentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyAdjustments'] = ResolversParentTypes['PropertyAdjustments']> = {
  coverage?: Resolver<ResolversTypes['PropertyCoverage'], ParentType, ContextType>;
  deductible?: Resolver<ResolversTypes['PropertyDeductible'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PropertyCoverageResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyCoverage'] = ResolversParentTypes['PropertyCoverage']> = {
  coverageA?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  coverageB?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  coverageC?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  coverageD?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  coverageE?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  coverageF?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  coverageL?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  coverageM?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  personalComputer?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  personalPropertyReplacement?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  waterBackup?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PropertyDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyData'] = ResolversParentTypes['PropertyData']> = {
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  addressId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  building?: Resolver<Maybe<ResolversTypes['Building']>, ParentType, ContextType>;
  homeowner?: Resolver<Maybe<ResolversTypes['Homeowner']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['Location']>, ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rebuildingCost?: Resolver<Maybe<ResolversTypes['RebuildingCost']>, ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  risk?: Resolver<Maybe<ResolversTypes['Risk']>, ParentType, ContextType>;
  site?: Resolver<Maybe<ResolversTypes['Site']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PropertyDataCreateErrorsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyDataCreateErrors'] = ResolversParentTypes['PropertyDataCreateErrors']> = {
  location?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  valuation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PropertyDataCreatedResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyDataCreated'] = ResolversParentTypes['PropertyDataCreated']> = {
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  addressId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  building?: Resolver<Maybe<ResolversTypes['Building']>, ParentType, ContextType>;
  errors?: Resolver<Maybe<ResolversTypes['PropertyDataCreateErrors']>, ParentType, ContextType>;
  homeowner?: Resolver<Maybe<ResolversTypes['Homeowner']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['Location']>, ParentType, ContextType>;
  propertyId?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  rebuildingCost?: Resolver<Maybe<ResolversTypes['RebuildingCost']>, ParentType, ContextType>;
  revision?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  risk?: Resolver<Maybe<ResolversTypes['Risk']>, ParentType, ContextType>;
  site?: Resolver<Maybe<ResolversTypes['Site']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PropertyDeductibleResolvers<ContextType = any, ParentType extends ResolversParentTypes['PropertyDeductible'] = ResolversParentTypes['PropertyDeductible']> = {
  base?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  earthquake?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  hurricane?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  theft?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  wind?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  windHail?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  windHailExcluded?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  address?: Resolver<ResolversTypes['Address'], ParentType, ContextType, RequireFields<QueryAddressArgs, 'id'>>;
  appointments?: Resolver<Array<ResolversTypes['Appointment']>, ParentType, ContextType>;
  homeQuoteRequest?: Resolver<ResolversTypes['HomeQuoteRequest'], ParentType, ContextType, RequireFields<QueryHomeQuoteRequestArgs, 'id'>>;
  homeQuoteRequestPoll?: Resolver<ResolversTypes['HomeQuoteRequestPoll'], ParentType, ContextType, RequireFields<QueryHomeQuoteRequestPollArgs, 'id'>>;
  organization?: Resolver<ResolversTypes['Organization'], ParentType, ContextType>;
  propertyAdjustments?: Resolver<ResolversTypes['PropertyAdjustments'], ParentType, ContextType, RequireFields<QueryPropertyAdjustmentsArgs, 'input'>>;
  propertyData?: Resolver<ResolversTypes['PropertyData'], ParentType, ContextType, RequireFields<QueryPropertyDataArgs, 'propertyId' | 'revision'>>;
};

export type QuoteRequestByResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuoteRequestBy'] = ResolversParentTypes['QuoteRequestBy']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RebuildingCostResolvers<ContextType = any, ParentType extends ResolversParentTypes['RebuildingCost'] = ResolversParentTypes['RebuildingCost']> = {
  hippo?: Resolver<Maybe<ResolversTypes['HippoRebuildingCost']>, ParentType, ContextType>;
  verisk?: Resolver<Maybe<ResolversTypes['VeriskRebuildingCost']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RiskResolvers<ContextType = any, ParentType extends ResolversParentTypes['Risk'] = ResolversParentTypes['Risk']> = {
  ppc?: Resolver<Maybe<ResolversTypes['PPC']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type RoofResolvers<ContextType = any, ParentType extends ResolversParentTypes['Roof'] = ResolversParentTypes['Roof']> = {
  material?: Resolver<Maybe<ResolversTypes['RoofMaterial']>, ParentType, ContextType>;
  style?: Resolver<Maybe<ResolversTypes['RoofStyle']>, ParentType, ContextType>;
  yearBuilt?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SiteResolvers<ContextType = any, ParentType extends ResolversParentTypes['Site'] = ResolversParentTypes['Site']> = {
  hasSecurityGuard?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasSwimmingPool?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasTrampoline?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  swimmingPool?: Resolver<Maybe<ResolversTypes['SwimmingPool']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type StallResolvers<ContextType = any, ParentType extends ResolversParentTypes['Stall'] = ResolversParentTypes['Stall']> = {
  count?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SwimmingPoolResolvers<ContextType = any, ParentType extends ResolversParentTypes['SwimmingPool'] = ResolversParentTypes['SwimmingPool']> = {
  hasSlide?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  installation?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isFenced?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UnderwritingMessageDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['UnderwritingMessageData'] = ResolversParentTypes['UnderwritingMessageData']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UtilityResolvers<ContextType = any, ParentType extends ResolversParentTypes['Utility'] = ResolversParentTypes['Utility']> = {
  electricYearUpdated?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  heatingYearUpdated?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  plumbingYearUpdated?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VeriskRebuildingCostResolvers<ContextType = any, ParentType extends ResolversParentTypes['VeriskRebuildingCost'] = ResolversParentTypes['VeriskRebuildingCost']> = {
  avgRebuildingCostPerSqFt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  high?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  low?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  medium?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  minRebuildingCostPerSqFt?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  Address?: AddressResolvers<ContextType>;
  Appointment?: AppointmentResolvers<ContextType>;
  Basement?: BasementResolvers<ContextType>;
  Bathroom?: BathroomResolvers<ContextType>;
  Bedroom?: BedroomResolvers<ContextType>;
  Building?: BuildingResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  ExteriorWall?: ExteriorWallResolvers<ContextType>;
  Fireplace?: FireplaceResolvers<ContextType>;
  Foundation?: FoundationResolvers<ContextType>;
  FullBathroom?: FullBathroomResolvers<ContextType>;
  Garage?: GarageResolvers<ContextType>;
  General?: GeneralResolvers<ContextType>;
  HalfBathroom?: HalfBathroomResolvers<ContextType>;
  HippoRebuildingCost?: HippoRebuildingCostResolvers<ContextType>;
  HomeApplicant?: HomeApplicantResolvers<ContextType>;
  HomeQuote?: HomeQuoteResolvers<ContextType>;
  HomeQuoteData?: HomeQuoteDataResolvers<ContextType>;
  HomeQuoteError?: HomeQuoteErrorResolvers<ContextType>;
  HomeQuotePending?: HomeQuotePendingResolvers<ContextType>;
  HomeQuoteRequest?: HomeQuoteRequestResolvers<ContextType>;
  HomeQuoteRequestPoll?: HomeQuoteRequestPollResolvers<ContextType>;
  HomeUpcomingCarrier?: HomeUpcomingCarrierResolvers<ContextType>;
  Homeowner?: HomeownerResolvers<ContextType>;
  Interior?: InteriorResolvers<ContextType>;
  JSONObject?: GraphQLScalarType;
  Location?: LocationResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  Organization?: OrganizationResolvers<ContextType>;
  OrganizationSupportedHomeProducts?: OrganizationSupportedHomeProductsResolvers<ContextType>;
  OrganizationSupportedLob?: OrganizationSupportedLobResolvers<ContextType>;
  PPC?: PpcResolvers<ContextType>;
  PageTracking?: PageTrackingResolvers<ContextType>;
  PropertyAdjustments?: PropertyAdjustmentsResolvers<ContextType>;
  PropertyCoverage?: PropertyCoverageResolvers<ContextType>;
  PropertyData?: PropertyDataResolvers<ContextType>;
  PropertyDataCreateErrors?: PropertyDataCreateErrorsResolvers<ContextType>;
  PropertyDataCreated?: PropertyDataCreatedResolvers<ContextType>;
  PropertyDeductible?: PropertyDeductibleResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  QuoteRequestBy?: QuoteRequestByResolvers<ContextType>;
  RebuildingCost?: RebuildingCostResolvers<ContextType>;
  Risk?: RiskResolvers<ContextType>;
  Roof?: RoofResolvers<ContextType>;
  Site?: SiteResolvers<ContextType>;
  Stall?: StallResolvers<ContextType>;
  SwimmingPool?: SwimmingPoolResolvers<ContextType>;
  UnderwritingMessageData?: UnderwritingMessageDataResolvers<ContextType>;
  Utility?: UtilityResolvers<ContextType>;
  VeriskRebuildingCost?: VeriskRebuildingCostResolvers<ContextType>;
};


export type CreateHomeQuoteRequestMutationVariables = Exact<{
  input: CreateHomeQuoteRequestInput;
}>;


export type CreateHomeQuoteRequestMutation = { __typename?: 'Mutation', createHomeQuoteRequest?: { __typename?: 'HomeQuoteRequest', id: string, referenceId?: string | null, createdAt: any, updatedAt: any, propertyId: string, propertyRevision: number, productName: ProductName, quoteMethod: QuoteRequestMethod, status: QuoteRequestStatus, quoteType: QuoteRequestType, residenceType: ResidenceType, selectedLob: Array<LineOfBusiness>, propertyData: { __typename?: 'PropertyData', propertyId: string, revision: number, addressId: string, building?: { __typename?: 'Building', general?: { __typename?: 'General', quality?: BuildingQuality | null, condition?: BuildingCondition | null, constructionStyle?: ConstructionStyle | null, familyUnits?: FamilyUnits | null, attachedness?: Attachedness | null, yearBuilt?: number | null, squareFootage?: number | null, stories?: Stories | null } | null, foundation?: { __typename?: 'Foundation', type?: FoundationType | null, slope?: FoundationSlope | null, basement?: { __typename?: 'Basement', finishedPercent?: number | null } | null } | null, exteriorWall?: { __typename?: 'ExteriorWall', structure?: ExteriorWallStructure | null, finish?: ExteriorWallFinish | null } | null, garage?: { __typename?: 'Garage', type?: GarageType | null, stall?: { __typename?: 'Stall', count?: number | null } | null } | null, roof?: { __typename?: 'Roof', material?: RoofMaterial | null, style?: RoofStyle | null, yearBuilt?: number | null } | null, interior?: { __typename?: 'Interior', hasBurglarAlarm?: boolean | null, hasDeadbolt?: boolean | null, hasFireAlarm?: boolean | null, hasFireExtinguisher?: boolean | null, hasFireSprinkler?: boolean | null, bathrooms?: { __typename?: 'Bathroom', half?: { __typename?: 'HalfBathroom', count?: number | null } | null, full?: { __typename?: 'FullBathroom', count?: number | null } | null } | null, bedrooms?: { __typename?: 'Bedroom', count?: number | null } | null, fireplace?: { __typename?: 'Fireplace', count?: number | null } | null } | null, utility?: { __typename?: 'Utility', electricYearUpdated?: number | null, heatingYearUpdated?: number | null, plumbingYearUpdated?: number | null } | null } | null, homeowner?: { __typename?: 'Homeowner', ownerIsLLC?: boolean | null, ownerIsTrust?: boolean | null, hasBeenVacantForAtLeast90Days?: boolean | null, isLastForeclosureForCurrentOwner?: boolean | null, lastForeclosureDate?: any | null, lastPurchaseDate?: any | null, lastPurchasePrice?: number | null, marketValue?: number | null, numberOfOpenMortgages?: number | null } | null, location?: { __typename?: 'Location', distanceToCoast?: number | null, distanceToFireStation?: number | null, distanceToWater?: number | null, feetToNearestHydrant?: FeetToNearestHydrant | null, withinCityLimit?: boolean | null } | null, rebuildingCost?: { __typename?: 'RebuildingCost', verisk?: { __typename?: 'VeriskRebuildingCost', low?: number | null, medium?: number | null, high?: number | null, minRebuildingCostPerSqFt?: number | null, avgRebuildingCostPerSqFt?: number | null } | null, hippo?: { __typename?: 'HippoRebuildingCost', medium?: number | null } | null } | null, risk?: { __typename?: 'Risk', ppc?: { __typename?: 'PPC', protectionClassISOAAIS?: ProtectionClassIsoaais | null, protectionClass?: string | null } | null } | null, site?: { __typename?: 'Site', hasSwimmingPool?: boolean | null, hasSecurityGuard?: boolean | null, hasTrampoline?: boolean | null, swimmingPool?: { __typename?: 'SwimmingPool', installation?: string | null, isFenced?: boolean | null, hasSlide?: boolean | null } | null } | null, address?: { __typename?: 'Address', id: string, street: string, street2?: string | null, city: string, state: StateName, county: string, zipcode: string, fiveDigitZipcode: string } | null }, applicant: { __typename?: 'HomeApplicant', firstName: string, middleName?: string | null, lastName: string, dateOfBirth: any, phone: string, email?: string | null, education: Education, occupation: Occupation, industry: Industry, maritalStatus?: MaritalStatus | null }, coverage?: { __typename?: 'PropertyCoverage', coverageA?: number | null, coverageB?: number | null, coverageC?: number | null, coverageD?: number | null, coverageE?: number | null, coverageF?: number | null, coverageL?: number | null, coverageM?: number | null, personalComputer?: number | null, personalPropertyReplacement?: number | null, waterBackup?: number | null } | null, deductible?: { __typename?: 'PropertyDeductible', base?: number | null, earthquake?: number | null, hurricane?: number | null, theft?: number | null, wind?: number | null, windHail?: number | null, windHailExcluded?: boolean | null } | null, quoteBy: { __typename?: 'QuoteRequestBy', id: string, name: string }, pageTracking?: Array<{ __typename?: 'PageTracking', key: string, value: string }> | null } | null };

export type CreatePropertyDataMutationVariables = Exact<{
  input: CreateAddressInput;
}>;


export type CreatePropertyDataMutation = { __typename?: 'Mutation', createPropertyData: { __typename?: 'PropertyDataCreated', propertyId: string, revision: number, addressId: string, building?: { __typename?: 'Building', general?: { __typename?: 'General', quality?: BuildingQuality | null, condition?: BuildingCondition | null, constructionStyle?: ConstructionStyle | null, familyUnits?: FamilyUnits | null, attachedness?: Attachedness | null, yearBuilt?: number | null, squareFootage?: number | null, stories?: Stories | null } | null, foundation?: { __typename?: 'Foundation', type?: FoundationType | null, slope?: FoundationSlope | null, basement?: { __typename?: 'Basement', finishedPercent?: number | null } | null } | null, exteriorWall?: { __typename?: 'ExteriorWall', structure?: ExteriorWallStructure | null, finish?: ExteriorWallFinish | null } | null, garage?: { __typename?: 'Garage', type?: GarageType | null, stall?: { __typename?: 'Stall', count?: number | null } | null } | null, roof?: { __typename?: 'Roof', material?: RoofMaterial | null, style?: RoofStyle | null, yearBuilt?: number | null } | null, interior?: { __typename?: 'Interior', hasBurglarAlarm?: boolean | null, hasDeadbolt?: boolean | null, hasFireAlarm?: boolean | null, hasFireExtinguisher?: boolean | null, hasFireSprinkler?: boolean | null, bathrooms?: { __typename?: 'Bathroom', half?: { __typename?: 'HalfBathroom', count?: number | null } | null, full?: { __typename?: 'FullBathroom', count?: number | null } | null } | null, bedrooms?: { __typename?: 'Bedroom', count?: number | null } | null, fireplace?: { __typename?: 'Fireplace', count?: number | null } | null } | null, utility?: { __typename?: 'Utility', electricYearUpdated?: number | null, heatingYearUpdated?: number | null, plumbingYearUpdated?: number | null } | null } | null, homeowner?: { __typename?: 'Homeowner', ownerIsLLC?: boolean | null, ownerIsTrust?: boolean | null, hasBeenVacantForAtLeast90Days?: boolean | null, isLastForeclosureForCurrentOwner?: boolean | null, lastForeclosureDate?: any | null, lastPurchaseDate?: any | null, lastPurchasePrice?: number | null, marketValue?: number | null, numberOfOpenMortgages?: number | null } | null, location?: { __typename?: 'Location', distanceToCoast?: number | null, distanceToFireStation?: number | null, distanceToWater?: number | null, feetToNearestHydrant?: FeetToNearestHydrant | null, withinCityLimit?: boolean | null } | null, rebuildingCost?: { __typename?: 'RebuildingCost', verisk?: { __typename?: 'VeriskRebuildingCost', low?: number | null, medium?: number | null, high?: number | null, minRebuildingCostPerSqFt?: number | null, avgRebuildingCostPerSqFt?: number | null } | null, hippo?: { __typename?: 'HippoRebuildingCost', medium?: number | null } | null } | null, risk?: { __typename?: 'Risk', ppc?: { __typename?: 'PPC', protectionClassISOAAIS?: ProtectionClassIsoaais | null, protectionClass?: string | null } | null } | null, site?: { __typename?: 'Site', hasSwimmingPool?: boolean | null, hasSecurityGuard?: boolean | null, hasTrampoline?: boolean | null, swimmingPool?: { __typename?: 'SwimmingPool', installation?: string | null, isFenced?: boolean | null, hasSlide?: boolean | null } | null } | null, address?: { __typename?: 'Address', id: string, street: string, street2?: string | null, city: string, state: StateName, county: string, zipcode: string, fiveDigitZipcode: string } | null, errors?: { __typename?: 'PropertyDataCreateErrors', location?: string | null, valuation?: string | null } | null } };

export type ExecuteQuoteRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ExecuteQuoteRequestMutation = { __typename?: 'Mutation', executeQuoteRequest: boolean };

export type UpdateHomeQuoteRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateHomeQuoteRequestInput;
}>;


export type UpdateHomeQuoteRequestMutation = { __typename?: 'Mutation', updateHomeQuoteRequest?: { __typename?: 'HomeQuoteRequest', id: string, referenceId?: string | null, createdAt: any, updatedAt: any, propertyId: string, propertyRevision: number, productName: ProductName, quoteMethod: QuoteRequestMethod, status: QuoteRequestStatus, quoteType: QuoteRequestType, residenceType: ResidenceType, selectedLob: Array<LineOfBusiness>, propertyData: { __typename?: 'PropertyData', propertyId: string, revision: number, addressId: string, building?: { __typename?: 'Building', general?: { __typename?: 'General', quality?: BuildingQuality | null, condition?: BuildingCondition | null, constructionStyle?: ConstructionStyle | null, familyUnits?: FamilyUnits | null, attachedness?: Attachedness | null, yearBuilt?: number | null, squareFootage?: number | null, stories?: Stories | null } | null, foundation?: { __typename?: 'Foundation', type?: FoundationType | null, slope?: FoundationSlope | null, basement?: { __typename?: 'Basement', finishedPercent?: number | null } | null } | null, exteriorWall?: { __typename?: 'ExteriorWall', structure?: ExteriorWallStructure | null, finish?: ExteriorWallFinish | null } | null, garage?: { __typename?: 'Garage', type?: GarageType | null, stall?: { __typename?: 'Stall', count?: number | null } | null } | null, roof?: { __typename?: 'Roof', material?: RoofMaterial | null, style?: RoofStyle | null, yearBuilt?: number | null } | null, interior?: { __typename?: 'Interior', hasBurglarAlarm?: boolean | null, hasDeadbolt?: boolean | null, hasFireAlarm?: boolean | null, hasFireExtinguisher?: boolean | null, hasFireSprinkler?: boolean | null, bathrooms?: { __typename?: 'Bathroom', half?: { __typename?: 'HalfBathroom', count?: number | null } | null, full?: { __typename?: 'FullBathroom', count?: number | null } | null } | null, bedrooms?: { __typename?: 'Bedroom', count?: number | null } | null, fireplace?: { __typename?: 'Fireplace', count?: number | null } | null } | null, utility?: { __typename?: 'Utility', electricYearUpdated?: number | null, heatingYearUpdated?: number | null, plumbingYearUpdated?: number | null } | null } | null, homeowner?: { __typename?: 'Homeowner', ownerIsLLC?: boolean | null, ownerIsTrust?: boolean | null, hasBeenVacantForAtLeast90Days?: boolean | null, isLastForeclosureForCurrentOwner?: boolean | null, lastForeclosureDate?: any | null, lastPurchaseDate?: any | null, lastPurchasePrice?: number | null, marketValue?: number | null, numberOfOpenMortgages?: number | null } | null, location?: { __typename?: 'Location', distanceToCoast?: number | null, distanceToFireStation?: number | null, distanceToWater?: number | null, feetToNearestHydrant?: FeetToNearestHydrant | null, withinCityLimit?: boolean | null } | null, rebuildingCost?: { __typename?: 'RebuildingCost', verisk?: { __typename?: 'VeriskRebuildingCost', low?: number | null, medium?: number | null, high?: number | null, minRebuildingCostPerSqFt?: number | null, avgRebuildingCostPerSqFt?: number | null } | null, hippo?: { __typename?: 'HippoRebuildingCost', medium?: number | null } | null } | null, risk?: { __typename?: 'Risk', ppc?: { __typename?: 'PPC', protectionClassISOAAIS?: ProtectionClassIsoaais | null, protectionClass?: string | null } | null } | null, site?: { __typename?: 'Site', hasSwimmingPool?: boolean | null, hasSecurityGuard?: boolean | null, hasTrampoline?: boolean | null, swimmingPool?: { __typename?: 'SwimmingPool', installation?: string | null, isFenced?: boolean | null, hasSlide?: boolean | null } | null } | null, address?: { __typename?: 'Address', id: string, street: string, street2?: string | null, city: string, state: StateName, county: string, zipcode: string, fiveDigitZipcode: string } | null }, applicant: { __typename?: 'HomeApplicant', firstName: string, middleName?: string | null, lastName: string, dateOfBirth: any, phone: string, email?: string | null, education: Education, occupation: Occupation, industry: Industry, maritalStatus?: MaritalStatus | null }, coverage?: { __typename?: 'PropertyCoverage', coverageA?: number | null, coverageB?: number | null, coverageC?: number | null, coverageD?: number | null, coverageE?: number | null, coverageF?: number | null, coverageL?: number | null, coverageM?: number | null, personalComputer?: number | null, personalPropertyReplacement?: number | null, waterBackup?: number | null } | null, deductible?: { __typename?: 'PropertyDeductible', base?: number | null, earthquake?: number | null, hurricane?: number | null, theft?: number | null, wind?: number | null, windHail?: number | null, windHailExcluded?: boolean | null } | null, quoteBy: { __typename?: 'QuoteRequestBy', id: string, name: string }, pageTracking?: Array<{ __typename?: 'PageTracking', key: string, value: string }> | null } | null };

export type UpdatePropertyMutationVariables = Exact<{
  propertyId: Scalars['ID']['input'];
  input: UpdatePropertyInput;
}>;


export type UpdatePropertyMutation = { __typename?: 'Mutation', updateProperty: { __typename?: 'PropertyData', propertyId: string, revision: number, addressId: string, building?: { __typename?: 'Building', general?: { __typename?: 'General', quality?: BuildingQuality | null, condition?: BuildingCondition | null, constructionStyle?: ConstructionStyle | null, familyUnits?: FamilyUnits | null, attachedness?: Attachedness | null, yearBuilt?: number | null, squareFootage?: number | null, stories?: Stories | null } | null, foundation?: { __typename?: 'Foundation', type?: FoundationType | null, slope?: FoundationSlope | null, basement?: { __typename?: 'Basement', finishedPercent?: number | null } | null } | null, exteriorWall?: { __typename?: 'ExteriorWall', structure?: ExteriorWallStructure | null, finish?: ExteriorWallFinish | null } | null, garage?: { __typename?: 'Garage', type?: GarageType | null, stall?: { __typename?: 'Stall', count?: number | null } | null } | null, roof?: { __typename?: 'Roof', material?: RoofMaterial | null, style?: RoofStyle | null, yearBuilt?: number | null } | null, interior?: { __typename?: 'Interior', hasBurglarAlarm?: boolean | null, hasDeadbolt?: boolean | null, hasFireAlarm?: boolean | null, hasFireExtinguisher?: boolean | null, hasFireSprinkler?: boolean | null, bathrooms?: { __typename?: 'Bathroom', half?: { __typename?: 'HalfBathroom', count?: number | null } | null, full?: { __typename?: 'FullBathroom', count?: number | null } | null } | null, bedrooms?: { __typename?: 'Bedroom', count?: number | null } | null, fireplace?: { __typename?: 'Fireplace', count?: number | null } | null } | null, utility?: { __typename?: 'Utility', electricYearUpdated?: number | null, heatingYearUpdated?: number | null, plumbingYearUpdated?: number | null } | null } | null, homeowner?: { __typename?: 'Homeowner', ownerIsLLC?: boolean | null, ownerIsTrust?: boolean | null, hasBeenVacantForAtLeast90Days?: boolean | null, isLastForeclosureForCurrentOwner?: boolean | null, lastForeclosureDate?: any | null, lastPurchaseDate?: any | null, lastPurchasePrice?: number | null, marketValue?: number | null, numberOfOpenMortgages?: number | null } | null, location?: { __typename?: 'Location', distanceToCoast?: number | null, distanceToFireStation?: number | null, distanceToWater?: number | null, feetToNearestHydrant?: FeetToNearestHydrant | null, withinCityLimit?: boolean | null } | null, rebuildingCost?: { __typename?: 'RebuildingCost', verisk?: { __typename?: 'VeriskRebuildingCost', low?: number | null, medium?: number | null, high?: number | null, minRebuildingCostPerSqFt?: number | null, avgRebuildingCostPerSqFt?: number | null } | null, hippo?: { __typename?: 'HippoRebuildingCost', medium?: number | null } | null } | null, risk?: { __typename?: 'Risk', ppc?: { __typename?: 'PPC', protectionClassISOAAIS?: ProtectionClassIsoaais | null, protectionClass?: string | null } | null } | null, site?: { __typename?: 'Site', hasSwimmingPool?: boolean | null, hasSecurityGuard?: boolean | null, hasTrampoline?: boolean | null, swimmingPool?: { __typename?: 'SwimmingPool', installation?: string | null, isFenced?: boolean | null, hasSlide?: boolean | null } | null } | null, address?: { __typename?: 'Address', id: string, street: string, street2?: string | null, city: string, state: StateName, county: string, zipcode: string, fiveDigitZipcode: string } | null } };

export type AddressQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AddressQuery = { __typename?: 'Query', address: { __typename?: 'Address', id: string, street: string, street2?: string | null, city: string, state: StateName, county: string, zipcode: string, fiveDigitZipcode: string } };

export type AppointmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type AppointmentsQuery = { __typename?: 'Query', appointments: Array<{ __typename?: 'Appointment', id: string, organizationId?: string | null, createdAt?: any | null, updatedAt?: any | null, name?: string | null, market?: string | null, lob?: string | null, consumerMarket?: string | null, products?: Array<string> | null, updatedBy?: any | null, integrationType?: AppointmentIntegrationType | null, isEnableForLeadFlow?: boolean | null, isActive?: boolean | null, isAvailableForQuoting?: boolean | null }> };

export type HomeQuoteRequestQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type HomeQuoteRequestQuery = { __typename?: 'Query', homeQuoteRequest: { __typename?: 'HomeQuoteRequest', id: string, referenceId?: string | null, createdAt: any, updatedAt: any, propertyId: string, propertyRevision: number, productName: ProductName, quoteMethod: QuoteRequestMethod, status: QuoteRequestStatus, quoteType: QuoteRequestType, residenceType: ResidenceType, selectedLob: Array<LineOfBusiness>, propertyData: { __typename?: 'PropertyData', propertyId: string, revision: number, addressId: string, building?: { __typename?: 'Building', general?: { __typename?: 'General', quality?: BuildingQuality | null, condition?: BuildingCondition | null, constructionStyle?: ConstructionStyle | null, familyUnits?: FamilyUnits | null, attachedness?: Attachedness | null, yearBuilt?: number | null, squareFootage?: number | null, stories?: Stories | null } | null, foundation?: { __typename?: 'Foundation', type?: FoundationType | null, slope?: FoundationSlope | null, basement?: { __typename?: 'Basement', finishedPercent?: number | null } | null } | null, exteriorWall?: { __typename?: 'ExteriorWall', structure?: ExteriorWallStructure | null, finish?: ExteriorWallFinish | null } | null, garage?: { __typename?: 'Garage', type?: GarageType | null, stall?: { __typename?: 'Stall', count?: number | null } | null } | null, roof?: { __typename?: 'Roof', material?: RoofMaterial | null, style?: RoofStyle | null, yearBuilt?: number | null } | null, interior?: { __typename?: 'Interior', hasBurglarAlarm?: boolean | null, hasDeadbolt?: boolean | null, hasFireAlarm?: boolean | null, hasFireExtinguisher?: boolean | null, hasFireSprinkler?: boolean | null, bathrooms?: { __typename?: 'Bathroom', half?: { __typename?: 'HalfBathroom', count?: number | null } | null, full?: { __typename?: 'FullBathroom', count?: number | null } | null } | null, bedrooms?: { __typename?: 'Bedroom', count?: number | null } | null, fireplace?: { __typename?: 'Fireplace', count?: number | null } | null } | null, utility?: { __typename?: 'Utility', electricYearUpdated?: number | null, heatingYearUpdated?: number | null, plumbingYearUpdated?: number | null } | null } | null, homeowner?: { __typename?: 'Homeowner', ownerIsLLC?: boolean | null, ownerIsTrust?: boolean | null, hasBeenVacantForAtLeast90Days?: boolean | null, isLastForeclosureForCurrentOwner?: boolean | null, lastForeclosureDate?: any | null, lastPurchaseDate?: any | null, lastPurchasePrice?: number | null, marketValue?: number | null, numberOfOpenMortgages?: number | null } | null, location?: { __typename?: 'Location', distanceToCoast?: number | null, distanceToFireStation?: number | null, distanceToWater?: number | null, feetToNearestHydrant?: FeetToNearestHydrant | null, withinCityLimit?: boolean | null } | null, rebuildingCost?: { __typename?: 'RebuildingCost', verisk?: { __typename?: 'VeriskRebuildingCost', low?: number | null, medium?: number | null, high?: number | null, minRebuildingCostPerSqFt?: number | null, avgRebuildingCostPerSqFt?: number | null } | null, hippo?: { __typename?: 'HippoRebuildingCost', medium?: number | null } | null } | null, risk?: { __typename?: 'Risk', ppc?: { __typename?: 'PPC', protectionClassISOAAIS?: ProtectionClassIsoaais | null, protectionClass?: string | null } | null } | null, site?: { __typename?: 'Site', hasSwimmingPool?: boolean | null, hasSecurityGuard?: boolean | null, hasTrampoline?: boolean | null, swimmingPool?: { __typename?: 'SwimmingPool', installation?: string | null, isFenced?: boolean | null, hasSlide?: boolean | null } | null } | null, address?: { __typename?: 'Address', id: string, street: string, street2?: string | null, city: string, state: StateName, county: string, zipcode: string, fiveDigitZipcode: string } | null }, applicant: { __typename?: 'HomeApplicant', firstName: string, middleName?: string | null, lastName: string, dateOfBirth: any, phone: string, email?: string | null, education: Education, occupation: Occupation, industry: Industry, maritalStatus?: MaritalStatus | null }, coverage?: { __typename?: 'PropertyCoverage', coverageA?: number | null, coverageB?: number | null, coverageC?: number | null, coverageD?: number | null, coverageE?: number | null, coverageF?: number | null, coverageL?: number | null, coverageM?: number | null, personalComputer?: number | null, personalPropertyReplacement?: number | null, waterBackup?: number | null } | null, deductible?: { __typename?: 'PropertyDeductible', base?: number | null, earthquake?: number | null, hurricane?: number | null, theft?: number | null, wind?: number | null, windHail?: number | null, windHailExcluded?: boolean | null } | null, quoteBy: { __typename?: 'QuoteRequestBy', id: string, name: string }, pageTracking?: Array<{ __typename?: 'PageTracking', key: string, value: string }> | null } };

export type HomeQuoteRequestPollQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type HomeQuoteRequestPollQuery = { __typename?: 'Query', homeQuoteRequestPoll: { __typename?: 'HomeQuoteRequestPoll', continuePolling: boolean, quoteRequestStatus: QuoteRequestStatus, quotes: Array<{ __typename?: 'HomeQuote', carrierName: string, carrierId: string, tooltip: string, logoUrl: string, error?: { __typename?: 'HomeQuoteError', errorStatus: ErrorStatus, errorType?: QuoteErrorType | null, errorCategory: QuoteCarrierErrorCategory, statusText: string } | null, data?: { __typename?: 'HomeQuoteData', agentUrl: string, computers: string, covA: number, covB: number, covC: number, covD: number, covE: number, covF: number, covL?: number | null, covM?: number | null, dicPresent?: string | null, downPayment?: number | null, equipmentBreakdown?: number | null, extendedReplacementCost?: number | null, herdId: string, homeOffice?: number | null, hvac?: string | null, isAdmitted?: boolean | null, isMonthlyPremiumSupported?: boolean | null, jewelry?: number | null, licenseLink?: string | null, link: string, lossAssessment?: number | null, monthlyPremium?: number | null, mortgagePaymentProtection?: boolean | null, numberOfMonthlyInstallments?: number | null, ordinanceOrLawProtection?: string | null, personalProperty?: number | null, personalPropertyReplacementCost?: boolean | null, policyBounded?: boolean | null, price: number, product: ProductName, purchaseType: PurchaseType, quoteId: string, quoteLicense?: string | null, term?: number | null, termLabel?: TermLabel | null, waterBackup?: number | null, deductibles: { __typename?: 'PropertyDeductible', base?: number | null, earthquake?: number | null, hurricane?: number | null, theft?: number | null, wind?: number | null, windHail?: number | null, windHailExcluded?: boolean | null }, underwritingMessage: Array<{ __typename?: 'UnderwritingMessageData', message: string }> } | null }>, pendingQuotes: Array<{ __typename?: 'HomeQuotePending', carrierId: string, carrierName: string, logoUrl: string }>, upcomingCarriers: Array<{ __typename?: 'HomeUpcomingCarrier', carrierId: string, carrierName: string, logoUrl: string, agentUrl?: string | null, isActive: boolean, isAvailableForQuoting: boolean }> } };

export type OrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', adhocBindEnabled: boolean, amsEnabled: boolean, amsForGatorEnabled: boolean, amsForSalesforceEnabled: boolean, authToken?: string | null, carrierTimeoutMessageEnabled: boolean, code?: string | null, crmAllowAddProducts: boolean, displayErrorsOnUi: boolean, enableAutoQuoteDocDownload: boolean, enableHomeQuoteDocDownload: boolean, feedbackEnabled: boolean, id: string, isVeriskPrefillAvailable: boolean, logoUrl?: string | null, name: string, templateName?: string | null, lob: { __typename?: 'OrganizationSupportedLob', auto?: boolean | null, cyberSecurity?: boolean | null, earthquake?: boolean | null, flood?: boolean | null, homeWarranty?: boolean | null, life?: boolean | null, pet?: boolean | null, umbrella?: boolean | null, home?: { __typename?: 'OrganizationSupportedHomeProducts', DP1?: boolean | null, DP3?: boolean | null, HO3?: boolean | null, HO4?: boolean | null, HO5?: boolean | null, HO6?: boolean | null, PUP?: boolean | null } | null }, appointments: Array<{ __typename?: 'Appointment', id: string, organizationId?: string | null, createdAt?: any | null, updatedAt?: any | null, name?: string | null, market?: string | null, lob?: string | null, consumerMarket?: string | null, products?: Array<string> | null, updatedBy?: any | null, integrationType?: AppointmentIntegrationType | null, isEnableForLeadFlow?: boolean | null, isActive?: boolean | null, isAvailableForQuoting?: boolean | null }> } };

export type PropertyAdjustmentsQueryVariables = Exact<{
  input: PropertyAdjustmentsInput;
}>;


export type PropertyAdjustmentsQuery = { __typename?: 'Query', propertyAdjustments: { __typename?: 'PropertyAdjustments', coverage: { __typename?: 'PropertyCoverage', coverageA?: number | null, coverageB?: number | null, coverageC?: number | null, coverageD?: number | null, coverageE?: number | null, coverageF?: number | null, coverageL?: number | null, coverageM?: number | null, personalComputer?: number | null, personalPropertyReplacement?: number | null, waterBackup?: number | null }, deductible: { __typename?: 'PropertyDeductible', base?: number | null, earthquake?: number | null, hurricane?: number | null, theft?: number | null, wind?: number | null, windHail?: number | null, windHailExcluded?: boolean | null } } };

export type PropertyDataQueryVariables = Exact<{
  propertyId: Scalars['ID']['input'];
  revision: Scalars['Int']['input'];
}>;


export type PropertyDataQuery = { __typename?: 'Query', propertyData: { __typename?: 'PropertyData', propertyId: string, revision: number, addressId: string, building?: { __typename?: 'Building', general?: { __typename?: 'General', quality?: BuildingQuality | null, condition?: BuildingCondition | null, constructionStyle?: ConstructionStyle | null, familyUnits?: FamilyUnits | null, attachedness?: Attachedness | null, yearBuilt?: number | null, squareFootage?: number | null, stories?: Stories | null } | null, foundation?: { __typename?: 'Foundation', type?: FoundationType | null, slope?: FoundationSlope | null, basement?: { __typename?: 'Basement', finishedPercent?: number | null } | null } | null, exteriorWall?: { __typename?: 'ExteriorWall', structure?: ExteriorWallStructure | null, finish?: ExteriorWallFinish | null } | null, garage?: { __typename?: 'Garage', type?: GarageType | null, stall?: { __typename?: 'Stall', count?: number | null } | null } | null, roof?: { __typename?: 'Roof', material?: RoofMaterial | null, style?: RoofStyle | null, yearBuilt?: number | null } | null, interior?: { __typename?: 'Interior', hasBurglarAlarm?: boolean | null, hasDeadbolt?: boolean | null, hasFireAlarm?: boolean | null, hasFireExtinguisher?: boolean | null, hasFireSprinkler?: boolean | null, bathrooms?: { __typename?: 'Bathroom', half?: { __typename?: 'HalfBathroom', count?: number | null } | null, full?: { __typename?: 'FullBathroom', count?: number | null } | null } | null, bedrooms?: { __typename?: 'Bedroom', count?: number | null } | null, fireplace?: { __typename?: 'Fireplace', count?: number | null } | null } | null, utility?: { __typename?: 'Utility', electricYearUpdated?: number | null, heatingYearUpdated?: number | null, plumbingYearUpdated?: number | null } | null } | null, homeowner?: { __typename?: 'Homeowner', ownerIsLLC?: boolean | null, ownerIsTrust?: boolean | null, hasBeenVacantForAtLeast90Days?: boolean | null, isLastForeclosureForCurrentOwner?: boolean | null, lastForeclosureDate?: any | null, lastPurchaseDate?: any | null, lastPurchasePrice?: number | null, marketValue?: number | null, numberOfOpenMortgages?: number | null } | null, location?: { __typename?: 'Location', distanceToCoast?: number | null, distanceToFireStation?: number | null, distanceToWater?: number | null, feetToNearestHydrant?: FeetToNearestHydrant | null, withinCityLimit?: boolean | null } | null, rebuildingCost?: { __typename?: 'RebuildingCost', verisk?: { __typename?: 'VeriskRebuildingCost', low?: number | null, medium?: number | null, high?: number | null, minRebuildingCostPerSqFt?: number | null, avgRebuildingCostPerSqFt?: number | null } | null, hippo?: { __typename?: 'HippoRebuildingCost', medium?: number | null } | null } | null, risk?: { __typename?: 'Risk', ppc?: { __typename?: 'PPC', protectionClassISOAAIS?: ProtectionClassIsoaais | null, protectionClass?: string | null } | null } | null, site?: { __typename?: 'Site', hasSwimmingPool?: boolean | null, hasSecurityGuard?: boolean | null, hasTrampoline?: boolean | null, swimmingPool?: { __typename?: 'SwimmingPool', installation?: string | null, isFenced?: boolean | null, hasSlide?: boolean | null } | null } | null, address?: { __typename?: 'Address', id: string, street: string, street2?: string | null, city: string, state: StateName, county: string, zipcode: string, fiveDigitZipcode: string } | null } };


export const CreateHomeQuoteRequestDocument = `
    mutation createHomeQuoteRequest($input: CreateHomeQuoteRequestInput!) {
  createHomeQuoteRequest(input: $input) {
    id
    referenceId
    createdAt
    updatedAt
    propertyId
    propertyRevision
    propertyData {
      building {
        general {
          quality
          condition
          constructionStyle
          familyUnits
          attachedness
          yearBuilt
          squareFootage
          stories
        }
        foundation {
          type
          basement {
            finishedPercent
          }
          slope
        }
        exteriorWall {
          structure
          finish
        }
        garage {
          stall {
            count
          }
          type
        }
        roof {
          material
          style
          yearBuilt
        }
        interior {
          bathrooms {
            half {
              count
            }
            full {
              count
            }
          }
          bedrooms {
            count
          }
          hasBurglarAlarm
          hasDeadbolt
          hasFireAlarm
          hasFireExtinguisher
          fireplace {
            count
          }
          hasFireSprinkler
        }
        utility {
          electricYearUpdated
          heatingYearUpdated
          plumbingYearUpdated
        }
      }
      homeowner {
        ownerIsLLC
        ownerIsTrust
        hasBeenVacantForAtLeast90Days
        isLastForeclosureForCurrentOwner
        lastForeclosureDate
        lastPurchaseDate
        lastPurchasePrice
        marketValue
        numberOfOpenMortgages
      }
      location {
        distanceToCoast
        distanceToFireStation
        distanceToWater
        feetToNearestHydrant
        withinCityLimit
      }
      rebuildingCost {
        verisk {
          low
          medium
          high
          minRebuildingCostPerSqFt
          avgRebuildingCostPerSqFt
        }
        hippo {
          medium
        }
      }
      risk {
        ppc {
          protectionClassISOAAIS
          protectionClass
        }
      }
      site {
        hasSwimmingPool
        hasSecurityGuard
        hasTrampoline
        swimmingPool {
          installation
          isFenced
          hasSlide
        }
      }
      propertyId
      revision
      addressId
      address {
        id
        street
        street2
        city
        state
        county
        zipcode
        fiveDigitZipcode
      }
    }
    productName
    applicant {
      firstName
      middleName
      lastName
      dateOfBirth
      phone
      email
      education
      occupation
      industry
      maritalStatus
    }
    coverage {
      coverageA
      coverageB
      coverageC
      coverageD
      coverageE
      coverageF
      coverageL
      coverageM
      personalComputer
      personalPropertyReplacement
      waterBackup
    }
    deductible {
      base
      earthquake
      hurricane
      theft
      wind
      windHail
      windHailExcluded
    }
    quoteBy {
      id
      name
    }
    pageTracking {
      key
      value
    }
    quoteMethod
    status
    quoteType
    residenceType
    selectedLob
  }
}
    `;
export const CreatePropertyDataDocument = `
    mutation createPropertyData($input: CreateAddressInput!) {
  createPropertyData(input: $input) {
    building {
      general {
        quality
        condition
        constructionStyle
        familyUnits
        attachedness
        yearBuilt
        squareFootage
        stories
      }
      foundation {
        type
        basement {
          finishedPercent
        }
        slope
      }
      exteriorWall {
        structure
        finish
      }
      garage {
        stall {
          count
        }
        type
      }
      roof {
        material
        style
        yearBuilt
      }
      interior {
        bathrooms {
          half {
            count
          }
          full {
            count
          }
        }
        bedrooms {
          count
        }
        hasBurglarAlarm
        hasDeadbolt
        hasFireAlarm
        hasFireExtinguisher
        fireplace {
          count
        }
        hasFireSprinkler
      }
      utility {
        electricYearUpdated
        heatingYearUpdated
        plumbingYearUpdated
      }
    }
    homeowner {
      ownerIsLLC
      ownerIsTrust
      hasBeenVacantForAtLeast90Days
      isLastForeclosureForCurrentOwner
      lastForeclosureDate
      lastPurchaseDate
      lastPurchasePrice
      marketValue
      numberOfOpenMortgages
    }
    location {
      distanceToCoast
      distanceToFireStation
      distanceToWater
      feetToNearestHydrant
      withinCityLimit
    }
    rebuildingCost {
      verisk {
        low
        medium
        high
        minRebuildingCostPerSqFt
        avgRebuildingCostPerSqFt
      }
      hippo {
        medium
      }
    }
    risk {
      ppc {
        protectionClassISOAAIS
        protectionClass
      }
    }
    site {
      hasSwimmingPool
      hasSecurityGuard
      hasTrampoline
      swimmingPool {
        installation
        isFenced
        hasSlide
      }
    }
    propertyId
    revision
    addressId
    address {
      id
      street
      street2
      city
      state
      county
      zipcode
      fiveDigitZipcode
    }
    errors {
      location
      valuation
    }
  }
}
    `;
export const ExecuteQuoteRequestDocument = `
    mutation executeQuoteRequest($id: ID!) {
  executeQuoteRequest(id: $id)
}
    `;
export const UpdateHomeQuoteRequestDocument = `
    mutation updateHomeQuoteRequest($id: ID!, $input: UpdateHomeQuoteRequestInput!) {
  updateHomeQuoteRequest(id: $id, input: $input) {
    id
    referenceId
    createdAt
    updatedAt
    propertyId
    propertyRevision
    propertyData {
      building {
        general {
          quality
          condition
          constructionStyle
          familyUnits
          attachedness
          yearBuilt
          squareFootage
          stories
        }
        foundation {
          type
          basement {
            finishedPercent
          }
          slope
        }
        exteriorWall {
          structure
          finish
        }
        garage {
          stall {
            count
          }
          type
        }
        roof {
          material
          style
          yearBuilt
        }
        interior {
          bathrooms {
            half {
              count
            }
            full {
              count
            }
          }
          bedrooms {
            count
          }
          hasBurglarAlarm
          hasDeadbolt
          hasFireAlarm
          hasFireExtinguisher
          fireplace {
            count
          }
          hasFireSprinkler
        }
        utility {
          electricYearUpdated
          heatingYearUpdated
          plumbingYearUpdated
        }
      }
      homeowner {
        ownerIsLLC
        ownerIsTrust
        hasBeenVacantForAtLeast90Days
        isLastForeclosureForCurrentOwner
        lastForeclosureDate
        lastPurchaseDate
        lastPurchasePrice
        marketValue
        numberOfOpenMortgages
      }
      location {
        distanceToCoast
        distanceToFireStation
        distanceToWater
        feetToNearestHydrant
        withinCityLimit
      }
      rebuildingCost {
        verisk {
          low
          medium
          high
          minRebuildingCostPerSqFt
          avgRebuildingCostPerSqFt
        }
        hippo {
          medium
        }
      }
      risk {
        ppc {
          protectionClassISOAAIS
          protectionClass
        }
      }
      site {
        hasSwimmingPool
        hasSecurityGuard
        hasTrampoline
        swimmingPool {
          installation
          isFenced
          hasSlide
        }
      }
      propertyId
      revision
      addressId
      address {
        id
        street
        street2
        city
        state
        county
        zipcode
        fiveDigitZipcode
      }
    }
    productName
    applicant {
      firstName
      middleName
      lastName
      dateOfBirth
      phone
      email
      education
      occupation
      industry
      maritalStatus
    }
    coverage {
      coverageA
      coverageB
      coverageC
      coverageD
      coverageE
      coverageF
      coverageL
      coverageM
      personalComputer
      personalPropertyReplacement
      waterBackup
    }
    deductible {
      base
      earthquake
      hurricane
      theft
      wind
      windHail
      windHailExcluded
    }
    quoteBy {
      id
      name
    }
    pageTracking {
      key
      value
    }
    quoteMethod
    status
    quoteType
    residenceType
    selectedLob
  }
}
    `;
export const UpdatePropertyDocument = `
    mutation updateProperty($propertyId: ID!, $input: UpdatePropertyInput!) {
  updateProperty(propertyId: $propertyId, input: $input) {
    building {
      general {
        quality
        condition
        constructionStyle
        familyUnits
        attachedness
        yearBuilt
        squareFootage
        stories
      }
      foundation {
        type
        basement {
          finishedPercent
        }
        slope
      }
      exteriorWall {
        structure
        finish
      }
      garage {
        stall {
          count
        }
        type
      }
      roof {
        material
        style
        yearBuilt
      }
      interior {
        bathrooms {
          half {
            count
          }
          full {
            count
          }
        }
        bedrooms {
          count
        }
        hasBurglarAlarm
        hasDeadbolt
        hasFireAlarm
        hasFireExtinguisher
        fireplace {
          count
        }
        hasFireSprinkler
      }
      utility {
        electricYearUpdated
        heatingYearUpdated
        plumbingYearUpdated
      }
    }
    homeowner {
      ownerIsLLC
      ownerIsTrust
      hasBeenVacantForAtLeast90Days
      isLastForeclosureForCurrentOwner
      lastForeclosureDate
      lastPurchaseDate
      lastPurchasePrice
      marketValue
      numberOfOpenMortgages
    }
    location {
      distanceToCoast
      distanceToFireStation
      distanceToWater
      feetToNearestHydrant
      withinCityLimit
    }
    rebuildingCost {
      verisk {
        low
        medium
        high
        minRebuildingCostPerSqFt
        avgRebuildingCostPerSqFt
      }
      hippo {
        medium
      }
    }
    risk {
      ppc {
        protectionClassISOAAIS
        protectionClass
      }
    }
    site {
      hasSwimmingPool
      hasSecurityGuard
      hasTrampoline
      swimmingPool {
        installation
        isFenced
        hasSlide
      }
    }
    propertyId
    revision
    addressId
    address {
      id
      street
      street2
      city
      state
      county
      zipcode
      fiveDigitZipcode
    }
  }
}
    `;
export const AddressDocument = `
    query address($id: ID!) {
  address(id: $id) {
    id
    street
    street2
    city
    state
    county
    zipcode
    fiveDigitZipcode
  }
}
    `;
export const AppointmentsDocument = `
    query appointments {
  appointments {
    id
    organizationId
    createdAt
    updatedAt
    name
    market
    lob
    consumerMarket
    products
    updatedBy
    integrationType
    isEnableForLeadFlow
    isActive
    isAvailableForQuoting
  }
}
    `;
export const HomeQuoteRequestDocument = `
    query homeQuoteRequest($id: ID!) {
  homeQuoteRequest(id: $id) {
    id
    referenceId
    createdAt
    updatedAt
    propertyId
    propertyRevision
    propertyData {
      building {
        general {
          quality
          condition
          constructionStyle
          familyUnits
          attachedness
          yearBuilt
          squareFootage
          stories
        }
        foundation {
          type
          basement {
            finishedPercent
          }
          slope
        }
        exteriorWall {
          structure
          finish
        }
        garage {
          stall {
            count
          }
          type
        }
        roof {
          material
          style
          yearBuilt
        }
        interior {
          bathrooms {
            half {
              count
            }
            full {
              count
            }
          }
          bedrooms {
            count
          }
          hasBurglarAlarm
          hasDeadbolt
          hasFireAlarm
          hasFireExtinguisher
          fireplace {
            count
          }
          hasFireSprinkler
        }
        utility {
          electricYearUpdated
          heatingYearUpdated
          plumbingYearUpdated
        }
      }
      homeowner {
        ownerIsLLC
        ownerIsTrust
        hasBeenVacantForAtLeast90Days
        isLastForeclosureForCurrentOwner
        lastForeclosureDate
        lastPurchaseDate
        lastPurchasePrice
        marketValue
        numberOfOpenMortgages
      }
      location {
        distanceToCoast
        distanceToFireStation
        distanceToWater
        feetToNearestHydrant
        withinCityLimit
      }
      rebuildingCost {
        verisk {
          low
          medium
          high
          minRebuildingCostPerSqFt
          avgRebuildingCostPerSqFt
        }
        hippo {
          medium
        }
      }
      risk {
        ppc {
          protectionClassISOAAIS
          protectionClass
        }
      }
      site {
        hasSwimmingPool
        hasSecurityGuard
        hasTrampoline
        swimmingPool {
          installation
          isFenced
          hasSlide
        }
      }
      propertyId
      revision
      addressId
      address {
        id
        street
        street2
        city
        state
        county
        zipcode
        fiveDigitZipcode
      }
    }
    productName
    applicant {
      firstName
      middleName
      lastName
      dateOfBirth
      phone
      email
      education
      occupation
      industry
      maritalStatus
    }
    coverage {
      coverageA
      coverageB
      coverageC
      coverageD
      coverageE
      coverageF
      coverageL
      coverageM
      personalComputer
      personalPropertyReplacement
      waterBackup
    }
    deductible {
      base
      earthquake
      hurricane
      theft
      wind
      windHail
      windHailExcluded
    }
    quoteBy {
      id
      name
    }
    pageTracking {
      key
      value
    }
    quoteMethod
    status
    quoteType
    residenceType
    selectedLob
  }
}
    `;
export const HomeQuoteRequestPollDocument = `
    query homeQuoteRequestPoll($id: ID!) {
  homeQuoteRequestPoll(id: $id) {
    continuePolling
    quoteRequestStatus
    quotes {
      carrierName
      carrierId
      tooltip
      logoUrl
      error {
        errorStatus
        errorType
        errorCategory
        statusText
      }
      data {
        agentUrl
        computers
        covA
        covB
        covC
        covD
        covE
        covF
        covL
        covM
        deductibles {
          base
          earthquake
          hurricane
          theft
          wind
          windHail
          windHailExcluded
        }
        dicPresent
        downPayment
        equipmentBreakdown
        extendedReplacementCost
        herdId
        homeOffice
        hvac
        isAdmitted
        isMonthlyPremiumSupported
        jewelry
        licenseLink
        link
        lossAssessment
        monthlyPremium
        mortgagePaymentProtection
        numberOfMonthlyInstallments
        ordinanceOrLawProtection
        personalProperty
        personalPropertyReplacementCost
        policyBounded
        price
        product
        purchaseType
        quoteId
        quoteLicense
        term
        termLabel
        underwritingMessage {
          message
        }
        waterBackup
      }
    }
    pendingQuotes {
      carrierId
      carrierName
      logoUrl
    }
    upcomingCarriers {
      carrierId
      carrierName
      logoUrl
      agentUrl
      isActive
      isAvailableForQuoting
    }
  }
}
    `;
export const OrganizationDocument = `
    query organization {
  organization {
    adhocBindEnabled
    amsEnabled
    amsForGatorEnabled
    amsForSalesforceEnabled
    authToken
    carrierTimeoutMessageEnabled
    code
    crmAllowAddProducts
    displayErrorsOnUi
    enableAutoQuoteDocDownload
    enableHomeQuoteDocDownload
    feedbackEnabled
    id
    isVeriskPrefillAvailable
    lob {
      auto
      cyberSecurity
      earthquake
      flood
      home {
        DP1
        DP3
        HO3
        HO4
        HO5
        HO6
        PUP
      }
      homeWarranty
      life
      pet
      umbrella
    }
    logoUrl
    name
    templateName
    appointments {
      id
      organizationId
      createdAt
      updatedAt
      name
      market
      lob
      consumerMarket
      products
      updatedBy
      integrationType
      isEnableForLeadFlow
      isActive
      isAvailableForQuoting
    }
  }
}
    `;
export const PropertyAdjustmentsDocument = `
    query propertyAdjustments($input: PropertyAdjustmentsInput!) {
  propertyAdjustments(input: $input) {
    coverage {
      coverageA
      coverageB
      coverageC
      coverageD
      coverageE
      coverageF
      coverageL
      coverageM
      personalComputer
      personalPropertyReplacement
      waterBackup
    }
    deductible {
      base
      earthquake
      hurricane
      theft
      wind
      windHail
      windHailExcluded
    }
  }
}
    `;
export const PropertyDataDocument = `
    query propertyData($propertyId: ID!, $revision: Int!) {
  propertyData(propertyId: $propertyId, revision: $revision) {
    building {
      general {
        quality
        condition
        constructionStyle
        familyUnits
        attachedness
        yearBuilt
        squareFootage
        stories
      }
      foundation {
        type
        basement {
          finishedPercent
        }
        slope
      }
      exteriorWall {
        structure
        finish
      }
      garage {
        stall {
          count
        }
        type
      }
      roof {
        material
        style
        yearBuilt
      }
      interior {
        bathrooms {
          half {
            count
          }
          full {
            count
          }
        }
        bedrooms {
          count
        }
        hasBurglarAlarm
        hasDeadbolt
        hasFireAlarm
        hasFireExtinguisher
        fireplace {
          count
        }
        hasFireSprinkler
      }
      utility {
        electricYearUpdated
        heatingYearUpdated
        plumbingYearUpdated
      }
    }
    homeowner {
      ownerIsLLC
      ownerIsTrust
      hasBeenVacantForAtLeast90Days
      isLastForeclosureForCurrentOwner
      lastForeclosureDate
      lastPurchaseDate
      lastPurchasePrice
      marketValue
      numberOfOpenMortgages
    }
    location {
      distanceToCoast
      distanceToFireStation
      distanceToWater
      feetToNearestHydrant
      withinCityLimit
    }
    rebuildingCost {
      verisk {
        low
        medium
        high
        minRebuildingCostPerSqFt
        avgRebuildingCostPerSqFt
      }
      hippo {
        medium
      }
    }
    risk {
      ppc {
        protectionClassISOAAIS
        protectionClass
      }
    }
    site {
      hasSwimmingPool
      hasSecurityGuard
      hasTrampoline
      swimmingPool {
        installation
        isFenced
        hasSlide
      }
    }
    propertyId
    revision
    addressId
    address {
      id
      street
      street2
      city
      state
      county
      zipcode
      fiveDigitZipcode
    }
  }
}
    `;

const injectedRtkApi = graphqlBaseApi.injectEndpoints({
  endpoints: (build) => ({
    createHomeQuoteRequest: build.mutation<CreateHomeQuoteRequestMutation, CreateHomeQuoteRequestMutationVariables>({
      query: (variables) => ({ document: CreateHomeQuoteRequestDocument, variables })
    }),
    createPropertyData: build.mutation<CreatePropertyDataMutation, CreatePropertyDataMutationVariables>({
      query: (variables) => ({ document: CreatePropertyDataDocument, variables })
    }),
    executeQuoteRequest: build.mutation<ExecuteQuoteRequestMutation, ExecuteQuoteRequestMutationVariables>({
      query: (variables) => ({ document: ExecuteQuoteRequestDocument, variables })
    }),
    updateHomeQuoteRequest: build.mutation<UpdateHomeQuoteRequestMutation, UpdateHomeQuoteRequestMutationVariables>({
      query: (variables) => ({ document: UpdateHomeQuoteRequestDocument, variables })
    }),
    updateProperty: build.mutation<UpdatePropertyMutation, UpdatePropertyMutationVariables>({
      query: (variables) => ({ document: UpdatePropertyDocument, variables })
    }),
    address: build.query<AddressQuery, AddressQueryVariables>({
      query: (variables) => ({ document: AddressDocument, variables })
    }),
    appointments: build.query<AppointmentsQuery, AppointmentsQueryVariables | void>({
      query: (variables) => ({ document: AppointmentsDocument, variables })
    }),
    homeQuoteRequest: build.query<HomeQuoteRequestQuery, HomeQuoteRequestQueryVariables>({
      query: (variables) => ({ document: HomeQuoteRequestDocument, variables })
    }),
    homeQuoteRequestPoll: build.query<HomeQuoteRequestPollQuery, HomeQuoteRequestPollQueryVariables>({
      query: (variables) => ({ document: HomeQuoteRequestPollDocument, variables })
    }),
    organization: build.query<OrganizationQuery, OrganizationQueryVariables | void>({
      query: (variables) => ({ document: OrganizationDocument, variables })
    }),
    propertyAdjustments: build.query<PropertyAdjustmentsQuery, PropertyAdjustmentsQueryVariables>({
      query: (variables) => ({ document: PropertyAdjustmentsDocument, variables })
    }),
    propertyData: build.query<PropertyDataQuery, PropertyDataQueryVariables>({
      query: (variables) => ({ document: PropertyDataDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };


